import { Component, Inject, Input, OnChanges, OnInit, SimpleChanges } from "@angular/core";
import { AuthService } from "@auth0/auth0-angular";
import { DialogService, DynamicDialogRef } from "primeng/dynamicdialog";
import { NGXLogger } from "ngx-logger";
import { DOCUMENT } from "@angular/common";
import { UserService } from "src/app/services/user.service";
import { AngularFirestore } from "@angular/fire/compat/firestore";
import { MessageService } from "primeng/api";

import { onSnapshot } from "firebase/firestore";
import { environment } from "src/environments/environment";
import { UtilService } from "src/app/services/util.service";
import { ExcelService } from "src/app/services/excelService.service";
import { ListeService } from "src/app/services/liste.service";
import { DatiDocFase1PerImpresa, DatiDocFase2PerImpresa, DatiDocFase3PerImpresa, PraticaFlowdy2_Firestore } from "src/app/models/praticaFirestore.model";

@Component({
  selector: "app-home-flowdy2-overall",
  templateUrl: "./home.flowdy2.overall.component.html",
  styleUrls: ["./home.flowdy2.overall.component.css"]
})
export class HomeFlowdy2OverallComponent implements OnInit, OnChanges {
  @Input() impresa: any;
  @Input() isImpresa: boolean = null;
  @Input() isPresidioTIM: boolean = null;
  @Input() isPresidioSF: boolean = null;

  ref: DynamicDialogRef;

  protected filtroRegione: string[] = [];
  protected filterIsSet: boolean = false;
  protected labelRegioni: string = 'Tutte le regioni';
  
  private collection_pratiche: string = environment.firebase.collection_pratiche;
  protected isLoading: boolean = false;

  // Dati per i tab
  protected datiRaggruppatiBando1Filtrati: PraticaFlowdy2_Firestore[] = [];
  protected datiRaggruppatiBando2Filtrati: PraticaFlowdy2_Firestore[] = [];
  protected datiRaggruppatiBando1: PraticaFlowdy2_Firestore[] = [];
  protected datiRaggruppatiBando2: PraticaFlowdy2_Firestore[] = [];

  showDaAttivareTable = false;
  showLavorabileTable = false;
  isDettaglioFuoriPerimetroVisible = false;
  isDettaglioVincoloInfratelVisible = false;
  isDettaglioVincoloOFVisible = false;
  isDettaglioVincoloFibercopVisible = false;
  isDettaglioVincoloTimVisible = false;

  protected activeTabIndex: number = 0;

  protected complessivoBando1: number = 0;

  protected complessivoBando1Attivate: number = 0;
  protected complessivoBando1AttivateLotto6: number = 0;
  protected complessivoBando1AttivateLotto7: number = 0;
  protected complessivoBando1DaAttivare: number = 0;
  protected complessivoBando1DaAttivareLotto6: number = 0;
  protected complessivoBando1DaAttivareLotto7: number = 0;
  protected complessivoBando1FuoriPerimetro: number = 0;
  protected complessivoBando1FuoriPerimetroLotto6: number = 0;
  protected complessivoBando1FuoriPerimetroLotto7: number = 0;

  protected complessivoBando2: number = 0;
  protected complessivoBando2Attivate: number = 0;
  protected complessivoBando2AttivateLotto1: number = 0;
  protected complessivoBando2AttivateLotto5: number = 0;
  protected complessivoBando2AttivateLotto7: number = 0;
  protected complessivoBando2AttivateLotto8: number = 0;
  protected complessivoBando2DaAttivare: number = 0;
  protected complessivoBando2DaAttivareLotto1: number = 0;
  protected complessivoBando2DaAttivareLotto5: number = 0;
  protected complessivoBando2DaAttivareLotto7: number = 0;
  protected complessivoBando2DaAttivareLotto8: number = 0;
  protected complessivoBando2FuoriPerimetro: number = 0;
  protected complessivoBando2FuoriPerimetroLotto1: number = 0;
  protected complessivoBando2FuoriPerimetroLotto5: number = 0;
  protected complessivoBando2FuoriPerimetroLotto7: number = 0;
  protected complessivoBando2FuoriPerimetroLotto8: number = 0;

  protected daAttivareBando1
  protected daAttivareBando1PF: number = 0;
  protected daAttivareBando1PFLotto6: number = 0;
  protected daAttivareBando1PFLotto7: number = 0;
  protected daAttivareBando1Lavorabile: number = 0;
  protected daAttivareBando1LavorabileLotto6: number = 0;
  protected daAttivareBando1LavorabileLotto7: number = 0;
  protected daAttivareBando1VincoloInfratel: number = 0;
  protected daAttivareBando1VincoloInfratelLotto6: number = 0;
  protected daAttivareBando1VincoloInfratelLotto7: number = 0;
  protected daAttivareBando1VincoloOF: number = 0;
  protected daAttivareBando1VincoloOFLotto6: number = 0;
  protected daAttivareBando1VincoloOFLotto7: number = 0;
  protected daAttivareBando1VincoloFibercop: number = 0;
  protected daAttivareBando1VincoloFibercopLotto6: number = 0;
  protected daAttivareBando1VincoloFibercopLotto7: number = 0;
  protected daAttivareBando1VincoloTim: number = 0;
  protected daAttivareBando1VincoloTimLotto6: number = 0;
  protected daAttivareBando1VincoloTimLotto7: number = 0;

  protected daAttivareBando2: number = 0;
  protected daAttivareBando2PF: number = 0;
  protected daAttivareBando2PFLotto1: number = 0;
  protected daAttivareBando2PFLotto5: number = 0;
  protected daAttivareBando2PFLotto7: number = 0;
  protected daAttivareBando2PFLotto8: number = 0;
  protected daAttivareBando2Lavorabile: number = 0;
  protected daAttivareBando2LavorabileLotto1: number = 0;
  protected daAttivareBando2LavorabileLotto5: number = 0;
  protected daAttivareBando2LavorabileLotto7: number = 0;
  protected daAttivareBando2LavorabileLotto8: number = 0;
  protected daAttivareBando2VincoloInfratel: number = 0;
  protected daAttivareBando2VincoloInfratelLotto1: number = 0;
  protected daAttivareBando2VincoloInfratelLotto5: number = 0;
  protected daAttivareBando2VincoloInfratelLotto7: number = 0;
  protected daAttivareBando2VincoloInfratelLotto8: number = 0;
  protected daAttivareBando2VincoloOF: number = 0;
  protected daAttivareBando2VincoloOFLotto1: number = 0;
  protected daAttivareBando2VincoloOFLotto5: number = 0;
  protected daAttivareBando2VincoloOFLotto7: number = 0;
  protected daAttivareBando2VincoloOFLotto8: number = 0;
  protected daAttivareBando2VincoloFibercop: number = 0;
  protected daAttivareBando2VincoloFibercopLotto1: number = 0;
  protected daAttivareBando2VincoloFibercopLotto5: number = 0;
  protected daAttivareBando2VincoloFibercopLotto7: number = 0;
  protected daAttivareBando2VincoloFibercopLotto8: number = 0;
  protected daAttivareBando2VincoloTim: number = 0;
  protected daAttivareBando2VincoloTimLotto1: number = 0;
  protected daAttivareBando2VincoloTimLotto5: number = 0;
  protected daAttivareBando2VincoloTimLotto7: number = 0;
  protected daAttivareBando2VincoloTimLotto8: number = 0;

  protected lavorabiliBando1: number = 0;
  protected lavorabiliBando1Lotto6: number = 0;
  protected lavorabiliBando1Lotto7: number = 0;
  protected lavorabiliBando1Tim: number = 0;
  protected lavorabiliBando1TimLotto6: number = 0;
  protected lavorabiliBando1TimLotto7: number = 0;
  protected lavorabiliBando1Fibercop: number = 0;
  protected lavorabiliBando1FibercopLotto6: number = 0;
  protected lavorabiliBando1FibercopLotto7: number = 0;
  protected lavorabiliBando1OF: number = 0;
  protected lavorabiliBando1OFLotto6: number = 0;
  protected lavorabiliBando1OFLotto7: number = 0;
  protected lavorabiliBando1Infratel: number = 0;
  protected lavorabiliBando1InfratelLotto6: number = 0;
  protected lavorabiliBando1InfratelLotto7: number = 0;

  protected vincoloInfratelBando1: number = 0;
  protected vincoloInfratelBando1Lotto6: number = 0;
  protected vincoloInfratelBando1Lotto7: number = 0;
  protected vincoloInfratelBando1_3_1: number = 0;
  protected vincoloInfratelBando1_3_1_Lotto6: number = 0;
  protected vincoloInfratelBando1_3_1_Lotto7: number = 0;
  protected vincoloInfratelBando1_3_2: number = 0;
  protected vincoloInfratelBando1_3_2_Lotto6: number = 0;
  protected vincoloInfratelBando1_3_2_Lotto7: number = 0;
  protected vincoloInfratelBando1_3_3: number = 0;
  protected vincoloInfratelBando1_3_3_Lotto6: number = 0;
  protected vincoloInfratelBando1_3_3_Lotto7: number = 0;
  protected vincoloInfratelBando1_3_4: number = 0;
  protected vincoloInfratelBando1_3_4_Lotto6: number = 0;
  protected vincoloInfratelBando1_3_4_Lotto7: number = 0;
  protected vincoloInfratelBando1_3_5: number = 0;
  protected vincoloInfratelBando1_3_5_Lotto6: number = 0;
  protected vincoloInfratelBando1_3_5_Lotto7: number = 0;
  protected vincoloInfratelBando1_3_6: number = 0;
  protected vincoloInfratelBando1_3_6_Lotto6: number = 0;
  protected vincoloInfratelBando1_3_6_Lotto7: number = 0;
  protected vincoloInfratelBando1_3_7: number = 0;
  protected vincoloInfratelBando1_3_7_Lotto6: number = 0;
  protected vincoloInfratelBando1_3_7_Lotto7: number = 0;
  protected vincoloInfratelBando1_3_8: number = 0;
  protected vincoloInfratelBando1_3_8_Lotto6: number = 0;
  protected vincoloInfratelBando1_3_8_Lotto7: number = 0;
  protected vincoloInfratelBando1_3_9: number = 0;
  protected vincoloInfratelBando1_3_9_Lotto6: number = 0;
  protected vincoloInfratelBando1_3_9_Lotto7: number = 0;
  protected vincoloInfratelBando1_3_10: number = 0;
  protected vincoloInfratelBando1_3_10_Lotto6: number = 0;
  protected vincoloInfratelBando1_3_10_Lotto7: number = 0;
  protected vincoloInfratelBando1_3_11: number = 0;
  protected vincoloInfratelBando1_3_11_Lotto6: number = 0;
  protected vincoloInfratelBando1_3_11_Lotto7: number = 0;
  protected vincoloInfratelBando1_3_12: number = 0;
  protected vincoloInfratelBando1_3_12_Lotto6: number = 0;
  protected vincoloInfratelBando1_3_12_Lotto7: number = 0;

  protected lavorabiliBando2: number = 0;
  protected lavorabiliBando2Lotto1: number = 0;
  protected lavorabiliBando2Lotto5: number = 0;
  protected lavorabiliBando2Lotto7: number = 0;
  protected lavorabiliBando2Lotto8: number = 0;

  protected lavorabiliBando2Tim: number = 0;
  protected lavorabiliBando2TimLotto1: number = 0;
  protected lavorabiliBando2TimLotto5: number = 0;
  protected lavorabiliBando2TimLotto7: number = 0;
  protected lavorabiliBando2TimLotto8: number = 0;

  protected lavorabiliBando2Infratel: number = 0;
  protected lavorabiliBando2InfratelLotto1: number = 0;
  protected lavorabiliBando2InfratelLotto5: number = 0;
  protected lavorabiliBando2InfratelLotto7: number = 0;
  protected lavorabiliBando2InfratelLotto8: number = 0;

  protected lavorabiliBando2OF: number = 0;
  protected lavorabiliBando2OFLotto1: number = 0;
  protected lavorabiliBando2OFLotto5: number = 0;
  protected lavorabiliBando2OFLotto7: number = 0;
  protected lavorabiliBando2OFLotto8: number = 0;

  protected lavorabiliBando2Fibercop: number = 0;
  protected lavorabiliBando2FibercopLotto1: number = 0;
  protected lavorabiliBando2FibercopLotto5: number = 0;
  protected lavorabiliBando2FibercopLotto7: number = 0;
  protected lavorabiliBando2FibercopLotto8: number = 0;

  protected vincoloInfratelBando2:        number = 0;

  protected vincoloInfratelBando2Lotto1:  number = 0;
  protected vincoloInfratelBando2Lotto5:  number = 0;
  protected vincoloInfratelBando2Lotto7:  number = 0;
  protected vincoloInfratelBando2Lotto8:  number = 0;

  protected vincoloInfratelBando2_3_1:      number = 0;
  protected vincoloInfratelBando2_3_1_Lotto1: number = 0;
  protected vincoloInfratelBando2_3_1_Lotto5: number = 0;
  protected vincoloInfratelBando2_3_1_Lotto7: number = 0;
  protected vincoloInfratelBando2_3_1_Lotto8: number = 0;

  protected vincoloInfratelBando2_3_2:      number = 0;
  protected vincoloInfratelBando2_3_2_Lotto1: number = 0;
  protected vincoloInfratelBando2_3_2_Lotto5: number = 0;
  protected vincoloInfratelBando2_3_2_Lotto7: number = 0;
  protected vincoloInfratelBando2_3_2_Lotto8: number = 0;

  protected vincoloInfratelBando2_3_3:        number = 0;
  protected vincoloInfratelBando2_3_3_Lotto1: number = 0;
  protected vincoloInfratelBando2_3_3_Lotto5: number = 0;
  protected vincoloInfratelBando2_3_3_Lotto7: number = 0;
  protected vincoloInfratelBando2_3_3_Lotto8: number = 0;

  protected vincoloInfratelBando2_3_4:        number = 0;
  protected vincoloInfratelBando2_3_4_Lotto1: number = 0;
  protected vincoloInfratelBando2_3_4_Lotto5: number = 0;
  protected vincoloInfratelBando2_3_4_Lotto7: number = 0;
  protected vincoloInfratelBando2_3_4_Lotto8: number = 0;

  protected vincoloInfratelBando2_3_5:        number = 0;
  protected vincoloInfratelBando2_3_5_Lotto1: number = 0;
  protected vincoloInfratelBando2_3_5_Lotto5: number = 0;
  protected vincoloInfratelBando2_3_5_Lotto7: number = 0;
  protected vincoloInfratelBando2_3_5_Lotto8: number = 0;

  protected vincoloInfratelBando2_3_6:        number = 0;
  protected vincoloInfratelBando2_3_6_Lotto1: number = 0;
  protected vincoloInfratelBando2_3_6_Lotto5: number = 0;
  protected vincoloInfratelBando2_3_6_Lotto7: number = 0;
  protected vincoloInfratelBando2_3_6_Lotto8: number = 0;

  protected vincoloInfratelBando2_3_7:        number = 0;
  protected vincoloInfratelBando2_3_7_Lotto1: number = 0;
  protected vincoloInfratelBando2_3_7_Lotto5: number = 0;
  protected vincoloInfratelBando2_3_7_Lotto7: number = 0;
  protected vincoloInfratelBando2_3_7_Lotto8: number = 0;

  protected vincoloInfratelBando2_3_8:        number = 0;
  protected vincoloInfratelBando2_3_8_Lotto1: number = 0;
  protected vincoloInfratelBando2_3_8_Lotto5: number = 0;
  protected vincoloInfratelBando2_3_8_Lotto7: number = 0;
  protected vincoloInfratelBando2_3_8_Lotto8: number = 0;

  protected vincoloInfratelBando2_3_9:        number = 0;
  protected vincoloInfratelBando2_3_9_Lotto1: number = 0;
  protected vincoloInfratelBando2_3_9_Lotto5: number = 0;
  protected vincoloInfratelBando2_3_9_Lotto7: number = 0;
  protected vincoloInfratelBando2_3_9_Lotto8: number = 0;

  protected vincoloInfratelBando2_3_10:        number = 0;
  protected vincoloInfratelBando2_3_10_Lotto1: number = 0;
  protected vincoloInfratelBando2_3_10_Lotto5: number = 0;
  protected vincoloInfratelBando2_3_10_Lotto7: number = 0;
  protected vincoloInfratelBando2_3_10_Lotto8: number = 0;

  protected vincoloInfratelBando2_3_11:        number = 0;
  protected vincoloInfratelBando2_3_11_Lotto1: number = 0;
  protected vincoloInfratelBando2_3_11_Lotto5: number = 0;
  protected vincoloInfratelBando2_3_11_Lotto7: number = 0;
  protected vincoloInfratelBando2_3_11_Lotto8: number = 0;

  protected vincoloInfratelBando2_3_12:        number = 0;
  protected vincoloInfratelBando2_3_12_Lotto1: number = 0;
  protected vincoloInfratelBando2_3_12_Lotto5: number = 0;
  protected vincoloInfratelBando2_3_12_Lotto7: number = 0;
  protected vincoloInfratelBando2_3_12_Lotto8: number = 0;

  protected vincoloOFBando1: number = 0;
  protected vincoloOFBando1Lotto6: number = 0;
  protected vincoloOFBando1Lotto7: number = 0;
  protected vincoloOFBando1_2_1: number = 0;
  protected vincoloOFBando1_2_1_Lotto6: number = 0;
  protected vincoloOFBando1_2_1_Lotto7: number = 0;
  protected vincoloOFBando1_2_2: number = 0;
  protected vincoloOFBando1_2_2_Lotto6: number = 0;
  protected vincoloOFBando1_2_2_Lotto7: number = 0;
  protected vincoloOFBando1_2_3: number = 0;
  protected vincoloOFBando1_2_3_Lotto6: number = 0;
  protected vincoloOFBando1_2_3_Lotto7: number = 0;
  protected vincoloOFBando1_2_4: number = 0;
  protected vincoloOFBando1_2_4_Lotto6: number = 0;
  protected vincoloOFBando1_2_4_Lotto7: number = 0;
  protected vincoloOFBando1_2_5: number = 0;
  protected vincoloOFBando1_2_5_Lotto6: number = 0;
  protected vincoloOFBando1_2_5_Lotto7: number = 0;
  protected vincoloOFBando1_2_6: number = 0;
  protected vincoloOFBando1_2_6_Lotto6: number = 0;
  protected vincoloOFBando1_2_6_Lotto7: number = 0;
  protected vincoloOFBando1_2_7: number = 0;
  protected vincoloOFBando1_2_7_Lotto6: number = 0;
  protected vincoloOFBando1_2_7_Lotto7: number = 0;
  protected vincoloOFBando1_2_8: number = 0;
  protected vincoloOFBando1_2_8_Lotto6: number = 0;
  protected vincoloOFBando1_2_8_Lotto7: number = 0;
  protected vincoloOFBando1_2_9: number = 0;
  protected vincoloOFBando1_2_9_Lotto6: number = 0;
  protected vincoloOFBando1_2_9_Lotto7: number = 0;




  protected vincoloOFBando2: number = 0;
  protected vincoloOFBando2Lotto1: number = 0;
  protected vincoloOFBando2Lotto5: number = 0;
  protected vincoloOFBando2Lotto7: number = 0;
  protected vincoloOFBando2Lotto8: number = 0;

  protected vincoloOFBando2_2_1: number = 0;
  protected vincoloOFBando2_2_1_Lotto1: number = 0;
  protected vincoloOFBando2_2_1_Lotto5: number = 0;
  protected vincoloOFBando2_2_1_Lotto7: number = 0;
  protected vincoloOFBando2_2_1_Lotto8: number = 0;

  protected vincoloOFBando2_2_2: number = 0;
  protected vincoloOFBando2_2_2_Lotto1: number = 0;
  protected vincoloOFBando2_2_2_Lotto5: number = 0;
  protected vincoloOFBando2_2_2_Lotto7: number = 0;
  protected vincoloOFBando2_2_2_Lotto8: number = 0;

  protected vincoloOFBando2_2_3: number = 0;
  protected vincoloOFBando2_2_3_Lotto1: number = 0;
  protected vincoloOFBando2_2_3_Lotto5: number = 0;
  protected vincoloOFBando2_2_3_Lotto7: number = 0;
  protected vincoloOFBando2_2_3_Lotto8: number = 0;

  protected vincoloOFBando2_2_4: number = 0;
  protected vincoloOFBando2_2_4_Lotto1: number = 0;
  protected vincoloOFBando2_2_4_Lotto5: number = 0;
  protected vincoloOFBando2_2_4_Lotto7: number = 0;
  protected vincoloOFBando2_2_4_Lotto8: number = 0;

  protected vincoloOFBando2_2_5: number = 0;
  protected vincoloOFBando2_2_5_Lotto1: number = 0;
  protected vincoloOFBando2_2_5_Lotto5: number = 0;
  protected vincoloOFBando2_2_5_Lotto7: number = 0;
  protected vincoloOFBando2_2_5_Lotto8: number = 0;

  protected vincoloOFBando2_2_6: number = 0;
  protected vincoloOFBando2_2_6_Lotto1: number = 0;
  protected vincoloOFBando2_2_6_Lotto5: number = 0;
  protected vincoloOFBando2_2_6_Lotto7: number = 0;
  protected vincoloOFBando2_2_6_Lotto8: number = 0;

  protected vincoloOFBando2_2_7: number = 0;
  protected vincoloOFBando2_2_7_Lotto1: number = 0;
  protected vincoloOFBando2_2_7_Lotto5: number = 0;
  protected vincoloOFBando2_2_7_Lotto7: number = 0;
  protected vincoloOFBando2_2_7_Lotto8: number = 0;

  protected vincoloOFBando2_2_8: number = 0;
  protected vincoloOFBando2_2_8_Lotto1: number = 0;
  protected vincoloOFBando2_2_8_Lotto5: number = 0;
  protected vincoloOFBando2_2_8_Lotto7: number = 0;
  protected vincoloOFBando2_2_8_Lotto8: number = 0;

  protected vincoloOFBando2_2_9: number = 0;
  protected vincoloOFBando2_2_9_Lotto1: number = 0;
  protected vincoloOFBando2_2_9_Lotto5: number = 0;
  protected vincoloOFBando2_2_9_Lotto7: number = 0;
  protected vincoloOFBando2_2_9_Lotto8: number = 0;

  protected vincoloFibercopBando1: number = 0;
  protected vincoloFibercopBando1Lotto6: number = 0;
  protected vincoloFibercopBando1Lotto7: number = 0;
  protected vincoloFibercopBando1_1_1: number = 0;
  protected vincoloFibercopBando1_1_1_Lotto6: number = 0;
  protected vincoloFibercopBando1_1_1_Lotto7: number = 0;
  protected vincoloFibercopBando1_1_2: number = 0;
  protected vincoloFibercopBando1_1_2_Lotto6: number = 0;
  protected vincoloFibercopBando1_1_2_Lotto7: number = 0;
  protected vincoloFibercopBando1_1_4: number = 0;
  protected vincoloFibercopBando1_1_4_Lotto6: number = 0;
  protected vincoloFibercopBando1_1_4_Lotto7: number = 0;
  protected vincoloFibercopBando1_1_6: number = 0;
  protected vincoloFibercopBando1_1_6_Lotto6: number = 0;
  protected vincoloFibercopBando1_1_6_Lotto7: number = 0;
  protected vincoloFibercopBando1_1_7: number = 0;
  protected vincoloFibercopBando1_1_7_Lotto6: number = 0;
  protected vincoloFibercopBando1_1_7_Lotto7: number = 0;


  protected vincoloFibercopBando2: number = 0;
  protected vincoloFibercopBando2Lotto1: number = 0;
  protected vincoloFibercopBando2Lotto5: number = 0;
  protected vincoloFibercopBando2Lotto7: number = 0;
  protected vincoloFibercopBando2Lotto8: number = 0;

  protected vincoloFibercopBando2_1_1: number = 0;
  protected vincoloFibercopBando2_1_1_Lotto1: number = 0;
  protected vincoloFibercopBando2_1_1_Lotto5: number = 0;
  protected vincoloFibercopBando2_1_1_Lotto7: number = 0;
  protected vincoloFibercopBando2_1_1_Lotto8: number = 0;
  
  protected vincoloFibercopBando2_1_2: number = 0;
  protected vincoloFibercopBando2_1_2_Lotto1: number = 0;
  protected vincoloFibercopBando2_1_2_Lotto5: number = 0;
  protected vincoloFibercopBando2_1_2_Lotto7: number = 0;
  protected vincoloFibercopBando2_1_2_Lotto8: number = 0;
  
  protected vincoloFibercopBando2_1_4: number = 0;
  protected vincoloFibercopBando2_1_4_Lotto1: number = 0;
  protected vincoloFibercopBando2_1_4_Lotto5: number = 0;
  protected vincoloFibercopBando2_1_4_Lotto7: number = 0;
  protected vincoloFibercopBando2_1_4_Lotto8: number = 0;
  
  protected vincoloFibercopBando2_1_6: number = 0;
  protected vincoloFibercopBando2_1_6_Lotto1: number = 0;
  protected vincoloFibercopBando2_1_6_Lotto5: number = 0;
  protected vincoloFibercopBando2_1_6_Lotto7: number = 0;
  protected vincoloFibercopBando2_1_6_Lotto8: number = 0;

  protected vincoloFibercopBando2_1_7: number = 0;
  protected vincoloFibercopBando2_1_7_Lotto1: number = 0;
  protected vincoloFibercopBando2_1_7_Lotto5: number = 0;
  protected vincoloFibercopBando2_1_7_Lotto7: number = 0;
  protected vincoloFibercopBando2_1_7_Lotto8: number = 0;

  protected vincoloTimBando1: number = 0;
  protected vincoloTimBando1Lotto6: number = 0;
  protected vincoloTimBando1Lotto7: number = 0;
  protected vincoloTimBando1_1_3: number = 0;
  protected vincoloTimBando1_1_3_Lotto6: number = 0;
  protected vincoloTimBando1_1_3_Lotto7: number = 0;
  protected vincoloTimBando1_1_5: number = 0;
  protected vincoloTimBando1_1_5_Lotto6: number = 0;
  protected vincoloTimBando1_1_5_Lotto7: number = 0;
  protected vincoloTimBando1_1_8: number = 0;
  protected vincoloTimBando1_1_8_Lotto6: number = 0;
  protected vincoloTimBando1_1_8_Lotto7: number = 0;
  protected vincoloTimBando1_1_9: number = 0;
  protected vincoloTimBando1_1_9_Lotto6: number = 0;
  protected vincoloTimBando1_1_9_Lotto7: number = 0;
  protected vincoloTimBando1_1_10: number = 0;
  protected vincoloTimBando1_1_10_Lotto6: number = 0;
  protected vincoloTimBando1_1_10_Lotto7: number = 0;
  protected vincoloTimBando1_1_11: number = 0;
  protected vincoloTimBando1_1_11_Lotto6: number = 0;
  protected vincoloTimBando1_1_11_Lotto7: number = 0;


  protected vincoloTimBando2: number = 0;
  protected vincoloTimBando2Lotto1: number = 0;
  protected vincoloTimBando2Lotto5: number = 0;
  protected vincoloTimBando2Lotto7: number = 0;
  protected vincoloTimBando2Lotto8: number = 0;

  protected vincoloTimBando2_1_3: number = 0;
  protected vincoloTimBando2_1_3_Lotto1: number = 0;
  protected vincoloTimBando2_1_3_Lotto5: number = 0;
  protected vincoloTimBando2_1_3_Lotto7: number = 0;
  protected vincoloTimBando2_1_3_Lotto8: number = 0;
  
  protected vincoloTimBando2_1_5: number = 0;
  protected vincoloTimBando2_1_5_Lotto1: number = 0;
  protected vincoloTimBando2_1_5_Lotto5: number = 0;
  protected vincoloTimBando2_1_5_Lotto7: number = 0;
  protected vincoloTimBando2_1_5_Lotto8: number = 0;

  protected vincoloTimBando2_1_8: number = 0;
  protected vincoloTimBando2_1_8_Lotto1: number = 0;
  protected vincoloTimBando2_1_8_Lotto5: number = 0;
  protected vincoloTimBando2_1_8_Lotto7: number = 0;
  protected vincoloTimBando2_1_8_Lotto8: number = 0;
  
  protected vincoloTimBando2_1_9: number = 0;
  protected vincoloTimBando2_1_9_Lotto1: number = 0;
  protected vincoloTimBando2_1_9_Lotto5: number = 0;
  protected vincoloTimBando2_1_9_Lotto7: number = 0;
  protected vincoloTimBando2_1_9_Lotto8: number = 0;

  protected vincoloTimBando2_1_10: number = 0;
  protected vincoloTimBando2_1_10_Lotto1: number = 0;
  protected vincoloTimBando2_1_10_Lotto5: number = 0;
  protected vincoloTimBando2_1_10_Lotto7: number = 0;
  protected vincoloTimBando2_1_10_Lotto8: number = 0;
  
  protected vincoloTimBando2_1_11: number = 0;
  protected vincoloTimBando2_1_11_Lotto1: number = 0;
  protected vincoloTimBando2_1_11_Lotto5: number = 0;
  protected vincoloTimBando2_1_11_Lotto7: number = 0;
  protected vincoloTimBando2_1_11_Lotto8: number = 0;

  protected fuoriPerimetroBando1: number = 0;
  protected fuoriPerimetroBando1Lotto6: number = 0;
  protected fuoriPerimetroBando1Lotto7: number = 0;

  protected fuoriPerimetroBando1_4_1: number = 0;
  protected fuoriPerimetroBando1_4_1_Lotto6: number = 0;
  protected fuoriPerimetroBando1_4_1_Lotto7: number = 0;
  
  protected fuoriPerimetroBando1_4_2: number = 0;
  protected fuoriPerimetroBando1_4_2_Lotto6: number = 0;
  protected fuoriPerimetroBando1_4_2_Lotto7: number = 0;

  protected fuoriPerimetroBando1_4_3: number = 0;
  protected fuoriPerimetroBando1_4_3_Lotto6: number = 0;
  protected fuoriPerimetroBando1_4_3_Lotto7: number = 0;

  protected fuoriPerimetroBando1_4_4: number = 0;
  protected fuoriPerimetroBando1_4_4_Lotto6: number = 0;
  protected fuoriPerimetroBando1_4_4_Lotto7: number = 0;

  
  protected fuoriPerimetroBando2: number = 0;
  protected fuoriPerimetroBando2Lotto1: number = 0;
  protected fuoriPerimetroBando2Lotto5: number = 0;
  protected fuoriPerimetroBando2Lotto7: number = 0;
  protected fuoriPerimetroBando2Lotto8: number = 0;

  protected fuoriPerimetroBando2_4_1: number = 0;
  protected fuoriPerimetroBando2_4_1_Lotto1: number = 0;
  protected fuoriPerimetroBando2_4_1_Lotto5: number = 0;
  protected fuoriPerimetroBando2_4_1_Lotto7: number = 0;
  protected fuoriPerimetroBando2_4_1_Lotto8: number = 0;

  protected fuoriPerimetroBando2_4_2: number = 0;
  protected fuoriPerimetroBando2_4_2_Lotto1: number = 0;
  protected fuoriPerimetroBando2_4_2_Lotto5: number = 0;
  protected fuoriPerimetroBando2_4_2_Lotto7: number = 0;
  protected fuoriPerimetroBando2_4_2_Lotto8: number = 0;
  
  protected fuoriPerimetroBando2_4_3: number = 0;
  protected fuoriPerimetroBando2_4_3_Lotto1: number = 0;
  protected fuoriPerimetroBando2_4_3_Lotto5: number = 0;
  protected fuoriPerimetroBando2_4_3_Lotto7: number = 0;
  protected fuoriPerimetroBando2_4_3_Lotto8: number = 0;
  
  protected fuoriPerimetroBando2_4_4: number = 0;
  protected fuoriPerimetroBando2_4_4_Lotto1: number = 0;
  protected fuoriPerimetroBando2_4_4_Lotto5: number = 0;
  protected fuoriPerimetroBando2_4_4_Lotto7: number = 0;
  protected fuoriPerimetroBando2_4_4_Lotto8: number = 0;
  
  

  constructor(
    public auth: AuthService,
    private userService: UserService,
    public dialogService: DialogService,
    private logger: NGXLogger,
    public firestore: AngularFirestore,
    public utilService: UtilService,
    public excelService: ExcelService,
    public listeService: ListeService,
    @Inject(DOCUMENT) private doc: Document,
    private messageService: MessageService
  ) {}

  ngOnInit() {
    this.logger.info("[HOME OVERALL] ON INIT PER UTENTE ");
    this.isLoading = true;
    Promise.all([
      this.loadDatiBando1(),
      this.loadDatiBando2()
    ]).finally(() => {
      this.isLoading = false;
    });
  }

  onFaseTabChange(event: any) {
    this.logger.info("[HOME OVERALL] FASE TAB CHANGE", event);
    this.activeTabIndex = event.index;
    this.resetVisualizzazioni();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['impresa'] && changes['impresa'].currentValue) {
      this.impresa = changes['impresa'].currentValue;
    }
    if (changes['isImpresa'] && changes['isImpresa'].currentValue) {
      this.isImpresa = changes['isImpresa'].currentValue;
    }
    if (changes['isPresidioTIM'] && changes['isPresidioTIM'].currentValue) {
      this.isPresidioTIM = changes['isPresidioTIM'].currentValue;
    }
  }

  private resetVisualizzazioni() {
    this.showDaAttivareTable = false;
    this.showLavorabileTable = false;
    this.isDettaglioFuoriPerimetroVisible = false;
    this.isDettaglioVincoloInfratelVisible = false;
    this.isDettaglioVincoloOFVisible = false;
    this.isDettaglioVincoloFibercopVisible = false;
    this.isDettaglioVincoloTimVisible = false;
  }

  onBandoTabChange(event: any) {
    this.showDaAttivareTable = false;
    this.showLavorabileTable = false;
    this.isDettaglioFuoriPerimetroVisible = false;
    this.isDettaglioVincoloInfratelVisible = false;
    this.isDettaglioVincoloOFVisible = false;
    this.isDettaglioVincoloFibercopVisible = false;
    this.isDettaglioVincoloTimVisible = false;
    this.filtroRegione = null;
    this.filterIsSet = false;
    this.labelRegioni = "TUTTE LE REGIONI";
    
    if (this.activeTabIndex == 0) {
      this.datiRaggruppatiBando1Filtrati = [];
      this.datiRaggruppatiBando1 = [];
      this.loadDatiBando1();
    } else {
      this.datiRaggruppatiBando2Filtrati = [];
      this.datiRaggruppatiBando2 = [];
      this.loadDatiBando2();
    }
  }

  loadDatiBando1() {
    this.logger.info("[HOME OVERALL] LOAD DATI BANDO 1");
    const collectionRef = this.firestore.collection(this.collection_pratiche).ref;
    let queryBando1;
    if(this.isImpresa){
      queryBando1 = collectionRef
                  .where("idAzienda", "==", this.userService.getUser().azienda.id)
                  .where("bando", "==", "BANDO 1")
                  .orderBy("azienda",'asc');
    }else{
      queryBando1 = collectionRef
                  .where("bando", "==", "BANDO 1")
                  .orderBy("statoFlowdyFase1")
                  .orderBy("azienda",'asc');
    }
    return new Promise((resolve) => {
      onSnapshot(queryBando1, (qs) => {
        this.resetTotaliBando1();
        this.datiRaggruppatiBando1 = [];
        this.datiRaggruppatiBando1Filtrati = [];
        this.logger.info("[HOME OVERALL] BANDO 1 RECUPERATI "+ qs.docs.length);
        qs.docs.forEach((doc) => {
          let praticaBando1DaFirestore: PraticaFlowdy2_Firestore = doc.data() as PraticaFlowdy2_Firestore;
          this.datiRaggruppatiBando1.push(praticaBando1DaFirestore);
          this.preparaDati(praticaBando1DaFirestore);
        });
        resolve(true);
      });
    });
  }

  preparaDati(praticaDaFirestore: PraticaFlowdy2_Firestore){
    this.loadDatiComplessivi(praticaDaFirestore);
    this.loadDatiDaAttivare(praticaDaFirestore);
    this.loadDatiLavorabili(praticaDaFirestore);
    this.loadDatiVincoloInfratel(praticaDaFirestore);
    this.loadDatiVincoloOF(praticaDaFirestore);
    this.loadDatiVincoloFibercop(praticaDaFirestore);
    this.loadDatiVincoloTim(praticaDaFirestore);
    this.loadDatiFuoriPerimetro(praticaDaFirestore);
  }

  loadDatiBando2() {
    this.logger.info("[HOME OVERALL] LOAD DATI BANDO 2");
    const collectionRef = this.firestore.collection(this.collection_pratiche).ref;
    let queryBando2;
    if(this.isImpresa){
      queryBando2 = collectionRef
                  .where("idAzienda", "==", this.userService.getUser().azienda.id)
                  .where("bando", "==", "BANDO 2")
                  .orderBy("azienda",'asc');
    }else{
      queryBando2 = collectionRef.where("bando", "==", "BANDO 2");
    }
    return new Promise((resolve) => {
      onSnapshot(queryBando2, (qs) => {
        this.resetTotaliBando2();
        this.datiRaggruppatiBando2 = [];
        this.datiRaggruppatiBando2Filtrati = [];
        this.logger.info("[HOME OVERALL] BANDO 2 RECUPERATI "+ qs.docs.length);
        qs.docs.forEach((doc) => {
          let praticaBando2DaFirestore: PraticaFlowdy2_Firestore = doc.data() as PraticaFlowdy2_Firestore;
          this.datiRaggruppatiBando2.push(praticaBando2DaFirestore);
          this.preparaDati(praticaBando2DaFirestore);
        });
        resolve(true);
      });
    });
  }

  loadDatiComplessivi(pratica: PraticaFlowdy2_Firestore){
    if(pratica.bando === 'BANDO 1'){
      this.complessivoBando1++;
      if(pratica.statoPF && pratica.statoPF.length > 0) {
        if(pratica.statoPF == "SEDE ATTIVATA" || pratica.statoPF == "ROUTER INSTALLATO") {
          this.complessivoBando1Attivate++;
          if(pratica.lotto == "6") {
            this.complessivoBando1AttivateLotto6++;
          } else {
            this.complessivoBando1AttivateLotto7++;
          }
        } else if(pratica.statoPF == "KO" && pratica.vincoloTipologiaID == 4) {
          this.complessivoBando1FuoriPerimetro++;
          if(pratica.lotto == "6") {
            this.complessivoBando1FuoriPerimetroLotto6++;
          } else {
            this.complessivoBando1FuoriPerimetroLotto7++;
          }
        } else {
          if(pratica.statoPF == "IN ATTESA" && pratica.vincoloTipologiaID == 4){
            this.complessivoBando1FuoriPerimetro++;
            if(pratica.lotto == "6"){
              this.complessivoBando1FuoriPerimetroLotto6++;
            }else if(pratica.lotto == "7"){
              this.complessivoBando1FuoriPerimetroLotto7++;
            }
           
           
          }else{
            this.complessivoBando1DaAttivare++;
            if(pratica.lotto == "6") {
              this.complessivoBando1DaAttivareLotto6++;
            } else {
              this.complessivoBando1DaAttivareLotto7++;
            }
          }
         
        }
      } else {
        if(pratica.vincoloTipologiaID == 4) {
          this.complessivoBando1FuoriPerimetro++;
          if(pratica.lotto == "6") {
            this.complessivoBando1FuoriPerimetroLotto6++;
          } else {
            this.complessivoBando1FuoriPerimetroLotto7++;
          }
        } else {
          this.complessivoBando1DaAttivare++;
          if(pratica.lotto == "6") {
            this.complessivoBando1DaAttivareLotto6++;
          } else {
            this.complessivoBando1DaAttivareLotto7++;
          }
        }
      }
    }else if(pratica.bando === 'BANDO 2'){
      this.complessivoBando2++;
      if(pratica.statoPF && pratica.statoPF.length > 0){
       if( pratica.statoPF == "SEDE ATTIVATA" || pratica.statoPF == "ROUTER INSTALLATO"){
         
         this.complessivoBando2Attivate++;
         if(pratica.lotto == "1"){
           this.complessivoBando2AttivateLotto1++;
         }else if(pratica.lotto == "5"){
           this.complessivoBando2AttivateLotto5++;
         }else if(pratica.lotto == "7"){
           this.complessivoBando2AttivateLotto7++;
         }else if(pratica.lotto == "8"){
           this.complessivoBando2AttivateLotto8++;
         }
       }else if(pratica.statoPF == "KO" && pratica.vincoloTipologiaID == 4){
        
           this.complessivoBando2FuoriPerimetro++;
           if(pratica.lotto == "1"){
             this.complessivoBando2FuoriPerimetroLotto1++;
           }else if(pratica.lotto == "5"){
             this.complessivoBando2FuoriPerimetroLotto5++;
           }else if(pratica.lotto == "7"){
             this.complessivoBando2FuoriPerimetroLotto7++;
           }else if(pratica.lotto == "8"){
             this.complessivoBando2FuoriPerimetroLotto8++;
           }
       }else {
        
         if(pratica.statoPF == "IN ATTESA" && pratica.vincoloTipologiaID == 4){
           this.complessivoBando2FuoriPerimetro++;
           if(pratica.lotto == "1"){
             this.complessivoBando2FuoriPerimetroLotto1++;
           }else if(pratica.lotto == "5"){
             this.complessivoBando2FuoriPerimetroLotto5++;
           }else if(pratica.lotto == "7"){
             this.complessivoBando2FuoriPerimetroLotto7++;
           }else if(pratica.lotto == "8"){
             this.complessivoBando2FuoriPerimetroLotto8++;
           }
          
         }else{
           this.complessivoBando2DaAttivare++;
              if(pratica.lotto == "1"){
             this.complessivoBando2DaAttivareLotto1++;
           }else if(pratica.lotto == "5"){
             this.complessivoBando2DaAttivareLotto5++;
           }else if(pratica.lotto == "7"){
             this.complessivoBando2DaAttivareLotto7++;
           }else if(pratica.lotto == "8"){
             this.complessivoBando2DaAttivareLotto8++;
           }
         }
         
         }
       }else{
         if(pratica.vincoloTipologiaID == 4){
           
           this.complessivoBando2FuoriPerimetro++;
           if(pratica.lotto == "1"){
             this.complessivoBando2FuoriPerimetroLotto1++;
           }else if(pratica.lotto == "5"){
             this.complessivoBando2FuoriPerimetroLotto5++;
           }else if(pratica.lotto == "7"){
             this.complessivoBando2FuoriPerimetroLotto7++;
           }else if(pratica.lotto == "8"){
             this.complessivoBando2FuoriPerimetroLotto8++;
           }
         }else{
           
           this.complessivoBando2DaAttivare++;
           if(pratica.lotto == "1"){
             this.complessivoBando2DaAttivareLotto1++;
           }else if(pratica.lotto == "5"){
             this.complessivoBando2DaAttivareLotto5++;
           }else if(pratica.lotto == "7"){
             this.complessivoBando2DaAttivareLotto7++;
           }else if(pratica.lotto == "8"){
             this.complessivoBando2DaAttivareLotto8++;
           }
        }
     
      }
    }
  }

  loadDatiDaAttivare(pratica: PraticaFlowdy2_Firestore) {
    if (pratica.bando === 'BANDO 1') {
      this.daAttivareBando1++;
      if(pratica.statoPF && pratica.statoPF == "PRONTO"){
        this.daAttivareBando1PF++;
        if(pratica.lotto == "6"){
          this.daAttivareBando1PFLotto6++;
        }else if(pratica.lotto == "7"){
          this.daAttivareBando1PFLotto7++;
        }
      }else if(!pratica.vincoloTipologiaID && (pratica.statoPF == "IN ATTESA" || !pratica.statoPF )){
        this.daAttivareBando1Lavorabile++;
        if(pratica.lotto == "6"){
          this.daAttivareBando1LavorabileLotto6++;
        }else if(pratica.lotto == "7"){
          this.daAttivareBando1LavorabileLotto7++;
        }
      }else if(pratica.statoPF && pratica.statoPF == "KO"){
        if(pratica.vincoloTipologiaID == 3){
          this.daAttivareBando1VincoloInfratel++;
          if(pratica.lotto == "6"){
            this.daAttivareBando1VincoloInfratelLotto6++;
          }else if(pratica.lotto == "7"){
            this.daAttivareBando1VincoloInfratelLotto7++;
          }
        }else if(pratica.vincoloTipologiaID == 2){
          this.daAttivareBando1VincoloOF++;
          if(pratica.lotto == "6"){
            this.daAttivareBando1VincoloOFLotto6++;
          }else if(pratica.lotto == "7"){
            this.daAttivareBando1VincoloOFLotto7++;
          }
        }else if(pratica.vincoloTipologiaID == 1 ){ 
          if (
            pratica.vincoloCategoriaCodice == '1.1' || 
            pratica.vincoloCategoriaCodice == '1.2' || 
            pratica.vincoloCategoriaCodice == '1.4' || 
            pratica.vincoloCategoriaCodice == '1.6' || 
            pratica.vincoloCategoriaCodice == '1.7' ){
            this.daAttivareBando1VincoloFibercop++;
            if(pratica.lotto == "6"){
              this.daAttivareBando1VincoloFibercopLotto6++;
            }else if(pratica.lotto == "7"){
              this.daAttivareBando1VincoloFibercopLotto7++;
            }
          }else if(
              pratica.vincoloCategoriaCodice == '1.3' || 
              pratica.vincoloCategoriaCodice == '1.5' || 
              pratica.vincoloCategoriaCodice == '1.8' ||
              pratica.vincoloCategoriaCodice == '1.9' ||
              pratica.vincoloCategoriaCodice == '1.10' ||
              pratica.vincoloCategoriaCodice == '1.11' ){
            this.daAttivareBando1VincoloTim++;
            if(pratica.lotto == "6"){
              this.daAttivareBando1VincoloTimLotto6++;
            }else if(pratica.lotto == "7"){
              this.daAttivareBando1VincoloTimLotto7++;
            }
          }
        }
      }
    } else if (pratica.bando === 'BANDO 2') {
      this.daAttivareBando2++;
      if(pratica.statoPF && pratica.statoPF == "PRONTO"){
        this.daAttivareBando2PF++;
        if(pratica.lotto == "1"){
          this.daAttivareBando2PFLotto1++;
        }else if(pratica.lotto == "5"){
          this.daAttivareBando2PFLotto5++;
        }else if(pratica.lotto == "7"){
          this.daAttivareBando2PFLotto7++;
        }else if(pratica.lotto == "8"){
          this.daAttivareBando2PFLotto8++;
        }
      }else if((pratica.statoPF == "IN ATTESA" || !pratica.statoPF )){
        if(!pratica.vincoloTipologiaID){
          this.daAttivareBando2Lavorabile++;
          if(pratica.lotto == "1"){
            this.daAttivareBando2LavorabileLotto1++;
          }else if(pratica.lotto == "5"){
            this.daAttivareBando2LavorabileLotto5++;
          }else if(pratica.lotto == "7"){
            this.daAttivareBando2LavorabileLotto7++;
          }else if(pratica.lotto == "8"){
            this.daAttivareBando2LavorabileLotto8++;
          }
        }else{
          if(pratica.vincoloTipologiaID == 3){
            this.daAttivareBando2VincoloInfratel++;
            if(pratica.lotto == "1"){
              this.daAttivareBando2VincoloInfratelLotto1++;
            }else if(pratica.lotto == "5"){
              this.daAttivareBando2VincoloInfratelLotto5++;
            }else if(pratica.lotto == "7"){
              this.daAttivareBando2VincoloInfratelLotto7++;
            }else if(pratica.lotto == "8"){
              this.daAttivareBando2VincoloInfratelLotto8++;
            }
          }else if(pratica.vincoloTipologiaID == 2){
            this.daAttivareBando2VincoloOF++;
            if(pratica.lotto == "1"){
              this.daAttivareBando2VincoloOFLotto1++;
            }else if(pratica.lotto == "5"){
              this.daAttivareBando2VincoloOFLotto5++;
            }else if(pratica.lotto == "7"){
              this.daAttivareBando2VincoloOFLotto7++;
            }else if(pratica.lotto == "8"){
              this.daAttivareBando2VincoloOFLotto8++;
            }
          }else if(pratica.vincoloTipologiaID == 1 ){ 
            if (
              pratica.vincoloCategoriaCodice == '1.1' || 
              pratica.vincoloCategoriaCodice == '1.2' || 
              pratica.vincoloCategoriaCodice == '1.4' || 
              pratica.vincoloCategoriaCodice == '1.6' || 
              pratica.vincoloCategoriaCodice == '1.7' ){
              this.daAttivareBando2VincoloFibercop++;
              if(pratica.lotto == "1"){
                this.daAttivareBando2VincoloFibercopLotto1++;
              }else if(pratica.lotto == "5"){
                this.daAttivareBando2VincoloFibercopLotto5++;
              }else if(pratica.lotto == "7"){
                this.daAttivareBando2VincoloFibercopLotto7++;
              }else if(pratica.lotto == "8"){
                this.daAttivareBando2VincoloFibercopLotto8++;
              }
            }else if(
                pratica.vincoloCategoriaCodice == '1.3' || 
                pratica.vincoloCategoriaCodice == '1.5' || 
                pratica.vincoloCategoriaCodice == '1.8' ||
                pratica.vincoloCategoriaCodice == '1.9' ||
                pratica.vincoloCategoriaCodice == '1.10' ||
                pratica.vincoloCategoriaCodice == '1.11' ){
              this.daAttivareBando2VincoloTim++;
              if(pratica.lotto == "1"){
                this.daAttivareBando2VincoloTimLotto1++;
              }else if(pratica.lotto == "5"){
                this.daAttivareBando2VincoloTimLotto5++;
              }else if(pratica.lotto == "7"){
                this.daAttivareBando2VincoloTimLotto7++;
              }else if(pratica.lotto == "8"){
                this.daAttivareBando2VincoloTimLotto8++;
              }
            }
          }
        }
      }else if(pratica.statoPF && pratica.statoPF == "KO"){
        if(pratica.vincoloTipologiaID == 3){
          this.daAttivareBando2VincoloInfratel++;
          if(pratica.lotto == "1"){
            this.daAttivareBando2VincoloInfratelLotto1++;
          }else if(pratica.lotto == "5"){
            this.daAttivareBando2VincoloInfratelLotto5++;
          }else if(pratica.lotto == "7"){
            this.daAttivareBando2VincoloInfratelLotto7++;
          }else if(pratica.lotto == "8"){
            this.daAttivareBando2VincoloInfratelLotto8++;
          }
        }else if(pratica.vincoloTipologiaID == 2){
          this.daAttivareBando2VincoloOF++;
          if(pratica.lotto == "1"){
            this.daAttivareBando2VincoloOFLotto1++;
          }else if(pratica.lotto == "5"){
            this.daAttivareBando2VincoloOFLotto5++;
          }else if(pratica.lotto == "7"){
            this.daAttivareBando2VincoloOFLotto7++;
          }else if(pratica.lotto == "8"){
            this.daAttivareBando2VincoloOFLotto8++;
          }
        }else if(pratica.vincoloTipologiaID == 1 ){ 
          if (
            pratica.vincoloCategoriaCodice == '1.1' || 
            pratica.vincoloCategoriaCodice == '1.2' || 
            pratica.vincoloCategoriaCodice == '1.4' || 
            pratica.vincoloCategoriaCodice == '1.6' || 
            pratica.vincoloCategoriaCodice == '1.7' ){
            this.daAttivareBando2VincoloFibercop++;
            if(pratica.lotto == "1"){
              this.daAttivareBando2VincoloFibercopLotto1++;
            }else if(pratica.lotto == "5"){
              this.daAttivareBando2VincoloFibercopLotto5++;
            }else if(pratica.lotto == "7"){
              this.daAttivareBando2VincoloFibercopLotto7++;
            }else if(pratica.lotto == "8"){
              this.daAttivareBando2VincoloFibercopLotto8++;
            }
          }else if(
              pratica.vincoloCategoriaCodice == '1.3' || 
              pratica.vincoloCategoriaCodice == '1.5' || 
              pratica.vincoloCategoriaCodice == '1.8' ||
              pratica.vincoloCategoriaCodice == '1.9' ||
              pratica.vincoloCategoriaCodice == '1.10' ||
              pratica.vincoloCategoriaCodice == '1.11' ){
            this.daAttivareBando2VincoloTim++;
            if(pratica.lotto == "1"){
              this.daAttivareBando2VincoloTimLotto1++;
            }else if(pratica.lotto == "5"){
              this.daAttivareBando2VincoloTimLotto5++;
            }else if(pratica.lotto == "7"){
              this.daAttivareBando2VincoloTimLotto7++;
            }else if(pratica.lotto == "8"){
              this.daAttivareBando2VincoloTimLotto8++;
            }
          }
        }
      }
    }
  }

  loadDatiLavorabili(pratica: PraticaFlowdy2_Firestore) {
    if (pratica.bando === 'BANDO 1') {
      this.lavorabiliBando1++;
      if(pratica.lotto == "6"){
        this.lavorabiliBando1Lotto6++;
      }else if(pratica.lotto == "7"){
        this.lavorabiliBando1Lotto7++;
      }
      if(pratica.statoPF && pratica.statoPF == "PRONTO"){
        this.lavorabiliBando1Tim++;
        if(pratica.lotto == "6"){
          this.lavorabiliBando1TimLotto6++;
        }else if(pratica.lotto == "7"){
          this.lavorabiliBando1TimLotto7++;
        }
      }else if((!pratica.statoPF || pratica.statoPF == "IN ATTESA") && !pratica.vincoloTipologiaID){
        if(pratica.tipoSedeEffettiva == "Mandatoria A"){
          this.lavorabiliBando1Infratel++;
          if(pratica.lotto == "6"){
            this.lavorabiliBando1InfratelLotto6++;
          }else if(pratica.lotto == "7"){
            this.lavorabiliBando1InfratelLotto7++;
          }
        }else if(pratica.tipoSedeEffettiva == "Mandatoria B" || pratica.tipoSedeEffettiva == "Mandatoria D" || pratica.tipoSedeEffettiva == "Aggiuntiva B" || pratica.tipoSedeEffettiva == "Aggiuntiva D"){
          this.lavorabiliBando1Fibercop++;
          if(pratica.lotto == "6"){
            this.lavorabiliBando1FibercopLotto6++;
          }else if(pratica.lotto == "7"){
            this.lavorabiliBando1FibercopLotto7++;
          }
        } else if(pratica.tipoSedeEffettiva == "Mandatoria C" ){
          this.lavorabiliBando1OF++;
          if(pratica.lotto == "6"){
            this.lavorabiliBando1OFLotto6++;
          }else if(pratica.lotto == "7"){
            this.lavorabiliBando1OFLotto7++;
          }
        } else{
          this.logger.info("BANDO 1 NON GESTITA "+ pratica.cui + " "+ pratica.tipoSedeEffettiva);
        }
      }


      
    } else if (pratica.bando === 'BANDO 2') {
      this.lavorabiliBando2++;
      if(pratica.lotto == "1"){
        this.lavorabiliBando2Lotto1++;
      }else if(pratica.lotto == "5"){
        this.lavorabiliBando2Lotto5++;
      }else if(pratica.lotto == "7"){
        this.lavorabiliBando2Lotto7++;  
      }else if(pratica.lotto == "8"){
        this.lavorabiliBando2Lotto8++;
      }
      if(pratica.statoPF && pratica.statoPF == "PRONTO"){
        this.lavorabiliBando2Tim++;
        if(pratica.lotto == "1"){
          this.lavorabiliBando2TimLotto1 ++;
        }else if(pratica.lotto == "5"){
          this.lavorabiliBando2TimLotto5++;
        }else if(pratica.lotto == "7"){
          this.lavorabiliBando2TimLotto7++;  
        }else if(pratica.lotto == "8"){
          this.lavorabiliBando2TimLotto8++;
        }
      }else if((!pratica.statoPF || pratica.statoPF == "IN ATTESA") && !pratica.vincoloTipologiaID){
        if(pratica.tipoSedeEffettiva == "B" ||  pratica.tipoSedeEffettiva == "B*" || pratica.tipoSedeEffettiva == "B**" || pratica.tipoSedeEffettiva == "D"){
          this.lavorabiliBando2Fibercop ++;
          if(pratica.lotto == "1"){
            this.lavorabiliBando2FibercopLotto1 ++;
          }else if(pratica.lotto == "5"){
            this.lavorabiliBando2FibercopLotto5++;
          }else if(pratica.lotto == "7"){
            this.lavorabiliBando2FibercopLotto7++;  
          }else if(pratica.lotto == "8"){
            this.lavorabiliBando2FibercopLotto8++;
          }
        }else if(pratica.tipoSedeEffettiva == "C" ){
          this.lavorabiliBando2OF++;
          if(pratica.lotto == "1"){
            this.lavorabiliBando2OFLotto1 ++;
          }else if(pratica.lotto == "5"){
            this.lavorabiliBando2OFLotto5++;
          }else if(pratica.lotto == "7"){
            this.lavorabiliBando2OFLotto7++;  
          }else if(pratica.lotto == "8"){
            this.lavorabiliBando2OFLotto8++;
          }
        } else if(pratica.tipoSedeEffettiva == "A" ){
          this.lavorabiliBando2Infratel++;
          if(pratica.lotto == "1"){
            this.lavorabiliBando2InfratelLotto1 ++;
          }else if(pratica.lotto == "5"){
            this.lavorabiliBando2InfratelLotto5++;
          }else if(pratica.lotto == "7"){
            this.lavorabiliBando2InfratelLotto7++;  
          }else if(pratica.lotto == "8"){
            this.lavorabiliBando2InfratelLotto8++;
          }
        } 
      }

    }
  }


  loadDatiVincoloInfratel(pratica: PraticaFlowdy2_Firestore) {
    if (pratica.bando === 'BANDO 1') {
      if((!pratica.statoPF || (pratica.statoPF && (pratica.statoPF == "IN ATTESA" || pratica.statoPF == "KO"))) && pratica.vincoloTipologiaID == 3){
        this.vincoloInfratelBando1++;
        if(pratica.lotto == "6"){
          this.vincoloInfratelBando1Lotto6++;
        }else if(pratica.lotto == "7"){
          this.vincoloInfratelBando1Lotto7++;
        }
        switch(pratica.vincoloCategoriaCodice){
          case '3.1':
            this.vincoloInfratelBando1_3_1++;
            if(pratica.lotto == "6"){
              this.vincoloInfratelBando1Lotto6++;
            }else if(pratica.lotto == "7"){
              this.vincoloInfratelBando1Lotto7++;
            }
            break;
          case '3.2':
            this.vincoloInfratelBando1_3_2++;
            if(pratica.lotto == "6"){
              this.vincoloInfratelBando1_3_2_Lotto6++;
            }else if(pratica.lotto == "7"){
              this.vincoloInfratelBando1_3_2_Lotto7++;
            }
            break;
          case '3.3':
            this.vincoloInfratelBando1_3_3++;
            if(pratica.lotto == "6"){
              this.vincoloInfratelBando1_3_3_Lotto6++;
            }else if(pratica.lotto == "7"){
              this.vincoloInfratelBando1_3_3_Lotto7++;
            }
            break;
          case '3.4':
            this.vincoloInfratelBando1_3_4++;
            if(pratica.lotto == "6"){
              this.vincoloInfratelBando1_3_4_Lotto6++;
            }else if(pratica.lotto == "7"){
              this.vincoloInfratelBando1_3_4_Lotto7++;
            }
            break;
          case '3.5':
            this.vincoloInfratelBando1_3_5++;
            if(pratica.lotto == "6"){
              this.vincoloInfratelBando1_3_5_Lotto6++;
            }else if(pratica.lotto == "7"){
              this.vincoloInfratelBando1_3_5_Lotto7++;
            }
            break;
          case '3.6':
            this.vincoloInfratelBando1_3_6++;
            if(pratica.lotto == "6"){
              this.vincoloInfratelBando1_3_6_Lotto6++;
            }else if(pratica.lotto == "7"){
              this.vincoloInfratelBando1_3_6_Lotto7++;
            }
            break;
          case '3.7':
            this.vincoloInfratelBando1_3_7++;
            if(pratica.lotto == "6"){
              this.vincoloInfratelBando1_3_7_Lotto6++;
            }else if(pratica.lotto == "7"){
              this.vincoloInfratelBando1_3_7_Lotto7++;
            }
            break;
          case '3.8':
            this.vincoloInfratelBando1_3_8++;
            if(pratica.lotto == "6"){
              this.vincoloInfratelBando1_3_8_Lotto6++;
            }else if(pratica.lotto == "7"){
              this.vincoloInfratelBando1_3_8_Lotto7++;
            }
            break;
          case '3.9':
            this.vincoloInfratelBando1_3_9++;
            if(pratica.lotto == "6"){
              this.vincoloInfratelBando1_3_9_Lotto6++;
            }else if(pratica.lotto == "7"){
              this.vincoloInfratelBando1_3_9_Lotto7++;
            }
            break;
          case '3.10':
            this.vincoloInfratelBando1_3_10++;
            if(pratica.lotto == "6"){
              this.vincoloInfratelBando1_3_10_Lotto6++;
            }else if(pratica.lotto == "7"){
              this.vincoloInfratelBando1_3_10_Lotto7++;
            }
            break;
          case '3.11':
            this.vincoloInfratelBando1_3_11++;
            if(pratica.lotto == "6"){
              this.vincoloInfratelBando1_3_11_Lotto6++;
            }else if(pratica.lotto == "7"){
              this.vincoloInfratelBando1_3_11_Lotto7++;
            }
            break;
          case '3.12':
            this.vincoloInfratelBando1_3_12++;
            if(pratica.lotto == "6"){
              this.vincoloInfratelBando1_3_12_Lotto6++;
            }else if(pratica.lotto == "7"){
              this.vincoloInfratelBando1_3_12_Lotto7++;
            }
            break;
          }
      }
      
    }else if (pratica.bando === 'BANDO 2') {
      if((!pratica.statoPF || (pratica.statoPF && (pratica.statoPF == "IN ATTESA" || pratica.statoPF == "KO"))) && pratica.vincoloTipologiaID == 3){
        this.vincoloInfratelBando2++;
        if(pratica.lotto == "1"){
          this.vincoloInfratelBando2Lotto1++;
        }else if(pratica.lotto == "5"){
          this.vincoloInfratelBando2Lotto5++;
        }else if(pratica.lotto == "7"){
          this.vincoloInfratelBando2Lotto7++;
        }else if(pratica.lotto == "8"){
          this.vincoloInfratelBando2Lotto8++;
        }
        switch(pratica.vincoloCategoriaCodice){
          case '3.1':
            this.vincoloInfratelBando2_3_1++;
            if(pratica.lotto == "1"){
              this.vincoloInfratelBando2_3_1_Lotto1++;
            }else if(pratica.lotto == "5"){
              this.vincoloInfratelBando2_3_1_Lotto5++;
            }else if(pratica.lotto == "7"){
              this.vincoloInfratelBando2_3_1_Lotto7++;
            }else if(pratica.lotto == "8"){
              this.vincoloInfratelBando2_3_1_Lotto8++;
            }
            break;
          case '3.2':
            this.vincoloInfratelBando2_3_2++;
            if(pratica.lotto == "1"){
              this.vincoloInfratelBando2_3_2_Lotto1++;
            }else if(pratica.lotto == "5"){
              this.vincoloInfratelBando2_3_2_Lotto5++;
            }else if(pratica.lotto == "7"){
              this.vincoloInfratelBando2_3_2_Lotto7++;
            }else if(pratica.lotto == "8"){
              this.vincoloInfratelBando2_3_2_Lotto8++;
            }
            break;
          case '3.3':
            this.vincoloInfratelBando2_3_3++;
            if(pratica.lotto == "1"){
              this.vincoloInfratelBando2_3_3_Lotto1++;
            }else if(pratica.lotto == "5"){
              this.vincoloInfratelBando2_3_3_Lotto5++;
            }else if(pratica.lotto == "7"){
              this.vincoloInfratelBando2_3_3_Lotto7++;
            }else if(pratica.lotto == "8"){
              this.vincoloInfratelBando2_3_3_Lotto8++;
            }
            break;
          case '3.4':
            this.vincoloInfratelBando2_3_4++;
            if(pratica.lotto == "1"){
              this.vincoloInfratelBando2_3_4_Lotto1++;
            }else if(pratica.lotto == "5"){
              this.vincoloInfratelBando2_3_4_Lotto5++;
            }else if(pratica.lotto == "7"){
              this.vincoloInfratelBando2_3_4_Lotto7++;
            }else if(pratica.lotto == "8"){
              this.vincoloInfratelBando2_3_4_Lotto8++;
            }
            break;
          case '3.5':
            this.vincoloInfratelBando2_3_5++;
            if(pratica.lotto == "1"){
              this.vincoloInfratelBando2_3_5_Lotto1++;
            }else if(pratica.lotto == "5"){
              this.vincoloInfratelBando2_3_5_Lotto5++;
            }else if(pratica.lotto == "7"){
              this.vincoloInfratelBando2_3_5_Lotto7++;
            }else if(pratica.lotto == "8"){
              this.vincoloInfratelBando2_3_5_Lotto8++;
            }
            break;
          case '3.6':
            this.vincoloInfratelBando2_3_6++;
            if(pratica.lotto == "1"){
              this.vincoloInfratelBando2_3_6_Lotto1++;
            }else if(pratica.lotto == "5"){
              this.vincoloInfratelBando2_3_6_Lotto5++;
            }else if(pratica.lotto == "7"){
              this.vincoloInfratelBando2_3_6_Lotto7++;
            }else if(pratica.lotto == "8"){
              this.vincoloInfratelBando2_3_6_Lotto8++;
            }
            break;
          case '3.7':
            this.vincoloInfratelBando2_3_7++;
            if(pratica.lotto == "1"){
              this.vincoloInfratelBando2_3_7_Lotto1++;
            }else if(pratica.lotto == "5"){
              this.vincoloInfratelBando2_3_7_Lotto5++;
            }else if(pratica.lotto == "7"){
              this.vincoloInfratelBando2_3_7_Lotto7++;
            }else if(pratica.lotto == "8"){
              this.vincoloInfratelBando2_3_7_Lotto8++;
            }
            break;
          case '3.8':
              this.vincoloInfratelBando2_3_8++;
            if(pratica.lotto == "1"){
              this.vincoloInfratelBando2_3_8_Lotto1++;
            }else if(pratica.lotto == "5"){
              this.vincoloInfratelBando2_3_8_Lotto5++;
            }else if(pratica.lotto == "7"){
              this.vincoloInfratelBando2_3_8_Lotto7++;
            }else if(pratica.lotto == "8"){
              this.vincoloInfratelBando2_3_8_Lotto8++;
            }
            break;
          case '3.9':
            this.vincoloInfratelBando2_3_9++;
            if(pratica.lotto == "1"){
              this.vincoloInfratelBando2_3_9_Lotto1++;
            }else if(pratica.lotto == "5"){
              this.vincoloInfratelBando2_3_9_Lotto5++;
            }else if(pratica.lotto == "7"){
              this.vincoloInfratelBando2_3_9_Lotto7++;
            }else if(pratica.lotto == "8"){
              this.vincoloInfratelBando2_3_9_Lotto8++;
            }
            break;
          case '3.10':
            this.vincoloInfratelBando2_3_10++;
            if(pratica.lotto == "1"){
              this.vincoloInfratelBando2_3_10_Lotto1++;
            }else if(pratica.lotto == "5"){
              this.vincoloInfratelBando2_3_10_Lotto5++;
            }else if(pratica.lotto == "7"){
              this.vincoloInfratelBando2_3_10_Lotto7++;
            }else if(pratica.lotto == "8"){
              this.vincoloInfratelBando2_3_10_Lotto8++;
            }
            break;
          case '3.11':
            this.vincoloInfratelBando2_3_11++;
            if(pratica.lotto == "1"){
              this.vincoloInfratelBando2_3_11_Lotto1++;
            }else if(pratica.lotto == "5"){
              this.vincoloInfratelBando2_3_11_Lotto5++;
            }else if(pratica.lotto == "7"){
              this.vincoloInfratelBando2_3_11_Lotto7++;
            }else if(pratica.lotto == "8"){
              this.vincoloInfratelBando2_3_11_Lotto8++;
            }
            break;
          case '3.12':
            this.vincoloInfratelBando2_3_12++;
            if(pratica.lotto == "1"){
              this.vincoloInfratelBando2_3_12_Lotto1++;
            }else if(pratica.lotto == "5"){
              this.vincoloInfratelBando2_3_12_Lotto5++;
            }else if(pratica.lotto == "7"){
              this.vincoloInfratelBando2_3_12_Lotto7++;
            }else if(pratica.lotto == "8"){
              this.vincoloInfratelBando2_3_12_Lotto8++;
            }
            break;
          default:
           // console.log("pratica sgarrata "+ pratica.cui  + " > " + pratica.vincoloCategoriaCodice);
            break;
          }
          

      }
    }
  }


  loadDatiVincoloOF(pratica: PraticaFlowdy2_Firestore) {
    if (pratica.bando === 'BANDO 1') {
      if((!pratica.statoPF || (pratica.statoPF && (pratica.statoPF == "IN ATTESA" || pratica.statoPF == "KO"))) && pratica.vincoloTipologiaID == 2){
        this.vincoloOFBando1++;
        if(pratica.lotto == "6"){
          this.vincoloOFBando1Lotto6++;
        }else if(pratica.lotto == "7"){
          this.vincoloOFBando1Lotto7++;
        }
        switch(pratica.vincoloCategoriaCodice){
          case '2.1':
            this.vincoloOFBando1_2_1++;
            if(pratica.lotto == "6"){
              this.vincoloOFBando1_2_1_Lotto6++;
            }else if(pratica.lotto == "7"){
              this.vincoloOFBando1_2_1_Lotto7++;
            }
            break;
          case '2.2':
            this.vincoloOFBando1_2_2++;
            if(pratica.lotto == "6"){
              this.vincoloOFBando1_2_2_Lotto6++;
            }else if(pratica.lotto == "7"){
              this.vincoloOFBando1_2_2_Lotto7++;
            }
            break;
          case '2.3':
            this.vincoloOFBando1_2_3++;
            if(pratica.lotto == "6"){
              this.vincoloOFBando1_2_3_Lotto6++;
            }else if(pratica.lotto == "7"){
              this.vincoloOFBando1_2_3_Lotto7++;
            }
            break;
          case '2.4':
            this.vincoloOFBando1_2_4++;
            if(pratica.lotto == "6"){
              this.vincoloOFBando1_2_4_Lotto6++;
            }else if(pratica.lotto == "7"){
              this.vincoloOFBando1_2_4_Lotto7++;
            }
            break;
          case '2.5':
            this.vincoloOFBando1_2_5++;
            if(pratica.lotto == "6"){
              this.vincoloOFBando1_2_5_Lotto6++;
            }else if(pratica.lotto == "7"){
              this.vincoloOFBando1_2_5_Lotto7++;
            }
            break;
          case '2.6':
            this.vincoloOFBando1_2_6++;
            if(pratica.lotto == "6"){
              this.vincoloOFBando1_2_6_Lotto6++;
            }else if(pratica.lotto == "7"){
              this.vincoloOFBando1_2_6_Lotto7++;
            }
            break;
          case '2.7':
            this.vincoloOFBando1_2_7++;
            if(pratica.lotto == "6"){
              this.vincoloOFBando1_2_7_Lotto6++;
            }else if(pratica.lotto == "7"){
              this.vincoloOFBando1_2_7_Lotto7++;
            }
            break;
          case '2.8':
            this.vincoloOFBando1_2_8++;
            if(pratica.lotto == "6"){
              this.vincoloOFBando1_2_8_Lotto6++;
            }else if(pratica.lotto == "7"){
              this.vincoloOFBando1_2_8_Lotto7++;
            }
            break;
          case '2.9':
            this.vincoloOFBando1_2_9++;
            if(pratica.lotto == "6"){
              this.vincoloOFBando1_2_9_Lotto6++;
            }else if(pratica.lotto == "7"){
              this.vincoloOFBando1_2_9_Lotto7++;
            }
            break;
          default:
           // console.log("pratica sgarrata "+ pratica.cui  + " > " + pratica.vincoloCategoriaCodice);    
          }
      }
      
    }else if (pratica.bando === 'BANDO 2') {
      if((!pratica.statoPF || (pratica.statoPF && (pratica.statoPF == "IN ATTESA" || pratica.statoPF == "KO"))) && pratica.vincoloTipologiaID == 2){
        this.vincoloOFBando2++;
        if(pratica.lotto == "1"){
          this.vincoloOFBando2Lotto1++;
        }else if(pratica.lotto == "5"){
          this.vincoloOFBando2Lotto5++;
        }else if(pratica.lotto == "7"){
          this.vincoloOFBando2Lotto7++;
        }else if(pratica.lotto == "8"){
          this.vincoloOFBando2Lotto8++;
        }
        switch(pratica.vincoloCategoriaCodice){
          case '2.1':
            this.vincoloOFBando2_2_1++;
            if(pratica.lotto == "1"){
              this.vincoloOFBando2_2_1_Lotto1++;
            }else if(pratica.lotto == "5"){
                  this.vincoloOFBando2_2_1_Lotto5++;
            }else if(pratica.lotto == "7"){
              this.vincoloOFBando2_2_1_Lotto7++;
            }else if(pratica.lotto == "8"){
              this.vincoloOFBando2_2_1_Lotto8++;
            }
            break;
          case '2.2':
            this.vincoloOFBando2_2_2++;
            if(pratica.lotto == "1"){
              this.vincoloOFBando2_2_2_Lotto1++;
            }else if(pratica.lotto == "5"){
              this.vincoloOFBando2_2_2_Lotto5++;
            }else if(pratica.lotto == "7"){
              this.vincoloOFBando2_2_2_Lotto7++;
            }else if(pratica.lotto == "8"){
              this.vincoloOFBando2_2_2_Lotto8++;
            }
            break;
          case '2.3':
            this.vincoloOFBando2_2_3++;
            if(pratica.lotto == "1"){
              this.vincoloOFBando2_2_3_Lotto1++;
            }else if(pratica.lotto == "5"){
              this.vincoloOFBando2_2_3_Lotto5++;
            }else if(pratica.lotto == "7"){
              this.vincoloOFBando2_2_3_Lotto7++;
            }else if(pratica.lotto == "8"){
              this.vincoloOFBando2_2_3_Lotto8++;
            }
            break;
          case '2.4':
            this.vincoloOFBando2_2_4++;
            if(pratica.lotto == "1"){
              this.vincoloOFBando2_2_4_Lotto1++;
            }else if(pratica.lotto == "5"){
              this.vincoloOFBando2_2_4_Lotto5++;
            }else if(pratica.lotto == "7"){
              this.vincoloOFBando2_2_4_Lotto7++;
            }else if(pratica.lotto == "8"){
              this.vincoloOFBando2_2_4_Lotto8++;
            }
            break;
          case '2.5':
            this.vincoloOFBando2_2_5++;
            if(pratica.lotto == "1"){
              this.vincoloOFBando2_2_5_Lotto1++;
            }else if(pratica.lotto == "5"){
              this.vincoloOFBando2_2_5_Lotto5++;
            }else if(pratica.lotto == "7"){
              this.vincoloOFBando2_2_5_Lotto7++;
            }else if(pratica.lotto == "8"){
              this.vincoloOFBando2_2_5_Lotto8++;
            }
            break;
          case '2.6':
            this.vincoloOFBando2_2_6++;
            if(pratica.lotto == "1"){
              this.vincoloOFBando2_2_6_Lotto1++;
            }else if(pratica.lotto == "5"){
              this.vincoloOFBando2_2_6_Lotto5++;
            }else if(pratica.lotto == "7"){
              this.vincoloOFBando2_2_6_Lotto7++;
            }else if(pratica.lotto == "8"){
              this.vincoloOFBando2_2_6_Lotto8++;
            }
            break;
          case '2.7':
            this.vincoloOFBando2_2_7++;
            if(pratica.lotto == "1"){
              this.vincoloOFBando2_2_7_Lotto1++;
            }else if(pratica.lotto == "5"){
              this.vincoloOFBando2_2_7_Lotto5++;
            }else if(pratica.lotto == "7"){
              this.vincoloOFBando2_2_7_Lotto7++;
            }else if(pratica.lotto == "8"){
              this.vincoloOFBando2_2_7_Lotto8++;
            }
            break;
          case '2.8':
            this.vincoloOFBando2_2_8++;
            if(pratica.lotto == "1"){
              this.vincoloOFBando2_2_8_Lotto1++;
            }else if(pratica.lotto == "5"){
              this.vincoloOFBando2_2_8_Lotto5++;
            }else if(pratica.lotto == "7"){
              this.vincoloOFBando2_2_8_Lotto7++;
            }else if(pratica.lotto == "8"){
              this.vincoloOFBando2_2_8_Lotto8++;
            }
            break;
          case '2.9':
            this.vincoloOFBando2_2_9++;
            if(pratica.lotto == "1"){
              this.vincoloOFBando2_2_9_Lotto1++;
            }else if(pratica.lotto == "5"){
              this.vincoloOFBando2_2_9_Lotto5++;
            }else if(pratica.lotto == "7"){
              this.vincoloOFBando2_2_9_Lotto7++;
            }else if(pratica.lotto == "8"){
              this.vincoloOFBando2_2_9_Lotto8++;
            }
            break;
          default:
           // console.log("pratica sgarrata "+ pratica.cui  + " > " + pratica.vincoloCategoriaCodice);
          }
      }
    }
  }

  loadDatiVincoloFibercop(pratica: PraticaFlowdy2_Firestore) {
    if (pratica.bando === 'BANDO 1') {
      if((!pratica.statoPF || (pratica.statoPF && (pratica.statoPF == "IN ATTESA" || pratica.statoPF == "KO"))) && pratica.vincoloTipologiaID == 1){
        this.vincoloFibercopBando1++;
        if(pratica.lotto == "6"){
          this.vincoloFibercopBando1Lotto6++;
        }else if(pratica.lotto == "7"){
          this.vincoloFibercopBando1Lotto7++;
        }
        switch(pratica.vincoloCategoriaCodice){
          case '1.1':
            this.vincoloFibercopBando1_1_1++;
            if(pratica.lotto == "6"){
              this.vincoloFibercopBando1_1_1_Lotto6++;
            }else if(pratica.lotto == "7"){
              this.vincoloFibercopBando1_1_1_Lotto7++;
            }
            break;
          case '1.2':
            this.vincoloFibercopBando1_1_2++;
            if(pratica.lotto == "6"){
              this.vincoloFibercopBando1_1_2_Lotto6++;
            }else if(pratica.lotto == "7"){
              this.vincoloOFBando1_2_2_Lotto7++;
            }
            break;
          case '1.4':
            this.vincoloFibercopBando1_1_4++;
            if(pratica.lotto == "6"){
              this.vincoloFibercopBando1_1_4_Lotto6++;
            }else if(pratica.lotto == "7"){
              this.vincoloFibercopBando1_1_4_Lotto7++;
            }
            break;
          case '1.6':
            this.vincoloFibercopBando1_1_6++;
            if(pratica.lotto == "6"){
              this.vincoloFibercopBando1_1_6_Lotto6++;
            }else if(pratica.lotto == "7"){
              this.vincoloFibercopBando1_1_6_Lotto7++;
            }
            break;
          case '1.7':
            this.vincoloFibercopBando1_1_7++;
            if(pratica.lotto == "6"){
              this.vincoloFibercopBando1_1_7_Lotto6++;
            }else if(pratica.lotto == "7"){
              this.vincoloFibercopBando1_1_7_Lotto7++;
            }
            break;
          
          default:
           // console.log("pratica sgarrata "+ pratica.cui  + " > " + pratica.vincoloCategoriaCodice);    
          }
      }
      
    }else if (pratica.bando === 'BANDO 2') {
      if((!pratica.statoPF || (pratica.statoPF && (pratica.statoPF == "IN ATTESA" || pratica.statoPF == "KO"))) && pratica.vincoloTipologiaID == 1){
        this.vincoloFibercopBando2++;
        if(pratica.lotto == "1"){
          this.vincoloFibercopBando2Lotto1++;
        }else if(pratica.lotto == "5"){
          this.vincoloFibercopBando2Lotto5++;
        }else if(pratica.lotto == "7"){
          this.vincoloFibercopBando2Lotto7++;
        }else if(pratica.lotto == "8"){
          this.vincoloFibercopBando2Lotto8++;
        }
        switch(pratica.vincoloCategoriaCodice){
          case '1.1':
            this.vincoloFibercopBando2_1_1++;
            if(pratica.lotto == "1"){
              this.vincoloFibercopBando2_1_1_Lotto1++;
            }else if(pratica.lotto == "5"){
                this.vincoloFibercopBando2_1_1_Lotto5++;
            }else if(pratica.lotto == "7"){
              this.vincoloFibercopBando2_1_1_Lotto7++;
            }else if(pratica.lotto == "8"){
              this.vincoloFibercopBando2_1_1_Lotto8++;
            }
            break;
          case '1.2':
            this.vincoloFibercopBando2_1_2++;
            if(pratica.lotto == "1"){
              this.vincoloFibercopBando2_1_2_Lotto1++;
            }else if(pratica.lotto == "5"){
              this.vincoloFibercopBando2_1_2_Lotto5++;
            }else if(pratica.lotto == "7"){
              this.vincoloFibercopBando2_1_2_Lotto7++;
            }else if(pratica.lotto == "8"){
              this.vincoloFibercopBando2_1_2_Lotto8++;
            }
            break;
          case '1.4':
            this.vincoloFibercopBando2_1_4++;
            if(pratica.lotto == "1"){
              this.vincoloFibercopBando2_1_4_Lotto1++;
            }else if(pratica.lotto == "5"){
              this.vincoloFibercopBando2_1_4_Lotto5++;
            }else if(pratica.lotto == "7"){
              this.vincoloFibercopBando2_1_4_Lotto7++;
            }else if(pratica.lotto == "8"){
              this.vincoloFibercopBando2_1_4_Lotto8++;
            }
            break;
          case '1.6':
            this.vincoloFibercopBando2_1_6++;
            if(pratica.lotto == "1"){
              this.vincoloFibercopBando2_1_6_Lotto1++;
            }else if(pratica.lotto == "5"){
              this.vincoloFibercopBando2_1_6_Lotto5++;
            }else if(pratica.lotto == "7"){
              this.vincoloFibercopBando2_1_6_Lotto7++;
            }else if(pratica.lotto == "8"){
              this.vincoloFibercopBando2_1_6_Lotto8++;
            }
            break;
          case '1.7':
            this.vincoloFibercopBando2_1_7++;
            if(pratica.lotto == "1"){
              this.vincoloFibercopBando2_1_7_Lotto1++;
            }else if(pratica.lotto == "5"){
              this.vincoloFibercopBando2_1_7_Lotto5++;
            }else if(pratica.lotto == "7"){
              this.vincoloFibercopBando2_1_7_Lotto7++;
            }else if(pratica.lotto == "8"){
              this.vincoloFibercopBando2_1_7_Lotto8++;
            }
            break;
         
          default:
           // console.log("pratica sgarrata "+ pratica.cui  + " > " + pratica.vincoloCategoriaCodice);
          }
      }
    }
  }

  loadDatiFuoriPerimetro(pratica: PraticaFlowdy2_Firestore) {
    if (pratica.bando === 'BANDO 1') {
      if(pratica.vincoloTipologiaID == 4){
        this.fuoriPerimetroBando1++;
        if(pratica.lotto == "6"){
          this.fuoriPerimetroBando1Lotto6++;
        }else if(pratica.lotto == "7"){
          this.fuoriPerimetroBando1Lotto7++;
        }
        switch(pratica.vincoloCategoriaCodice){
          case '4.1':
            this.fuoriPerimetroBando1_4_1++;
            if(pratica.lotto == "6"){
              this.fuoriPerimetroBando1_4_1_Lotto6++;
            }else if(pratica.lotto == "7"){
              this.fuoriPerimetroBando1_4_1_Lotto7++;
            }
            break;
          case '4.2':
            this.fuoriPerimetroBando1_4_2++;
            if(pratica.lotto == "6"){
              this.fuoriPerimetroBando1_4_2_Lotto6++;
            }else if(pratica.lotto == "7"){
              this.fuoriPerimetroBando1_4_2_Lotto7++;
            }
            break;
          case '4.3':
            this.fuoriPerimetroBando1_4_3++;
            if(pratica.lotto == "6"){
              this.fuoriPerimetroBando1_4_3_Lotto6++;
            }else if(pratica.lotto == "7"){
              this.fuoriPerimetroBando1_4_3_Lotto7++;
            }
            break;
          case '4.4':
            this.fuoriPerimetroBando1_4_4++;
            if(pratica.lotto == "6"){
              this.fuoriPerimetroBando1_4_4_Lotto6++;
            }else if(pratica.lotto == "7"){
              this.fuoriPerimetroBando1_4_4_Lotto7++;
            }
            break;
        }
      }
    }else if (pratica.bando === 'BANDO 2') {
      if(pratica.vincoloTipologiaID == 4){
        this.fuoriPerimetroBando2++;
        if(pratica.lotto == "1"){
          this.fuoriPerimetroBando2Lotto1++;
        }else if(pratica.lotto == "5"){
          this.fuoriPerimetroBando2Lotto5++;
        }else if(pratica.lotto == "7"){
          this.fuoriPerimetroBando2Lotto7++;
        }else if(pratica.lotto == "8"){
          this.fuoriPerimetroBando2Lotto8++;
        }
        switch(pratica.vincoloCategoriaCodice){
          case '4.1':
            this.fuoriPerimetroBando2_4_1++;
            if(pratica.lotto == "1"){
              this.fuoriPerimetroBando2_4_1_Lotto1++;
            }else if(pratica.lotto == "5"){
              this.fuoriPerimetroBando2_4_1_Lotto5++;
            }else if(pratica.lotto == "7"){
              this.fuoriPerimetroBando2_4_1_Lotto7++;
            }else if(pratica.lotto == "8"){
              this.fuoriPerimetroBando2_4_1_Lotto8++;
            }
            break;
          case '4.2':
            this.fuoriPerimetroBando2_4_2++;
            if(pratica.lotto == "1"){
              this.fuoriPerimetroBando2_4_2_Lotto1++;
            }else if(pratica.lotto == "5"){
              this.fuoriPerimetroBando2_4_2_Lotto5++;
            }else if(pratica.lotto == "7"){
              this.fuoriPerimetroBando2_4_2_Lotto7++;
            }else if(pratica.lotto == "8"){
              this.fuoriPerimetroBando2_4_2_Lotto8++;
            }
            break;
          case '4.3':
            this.fuoriPerimetroBando2_4_3++;
            if(pratica.lotto == "1"){
              this.fuoriPerimetroBando2_4_3_Lotto1++;
            }else if(pratica.lotto == "5"){
              this.fuoriPerimetroBando2_4_3_Lotto5++;
            }else if(pratica.lotto == "7"){
              this.fuoriPerimetroBando2_4_3_Lotto7++;
            }else if(pratica.lotto == "8"){
              this.fuoriPerimetroBando2_4_3_Lotto8++;
            }
            break;
          case '4.4':
            this.fuoriPerimetroBando2_4_4++;
            if(pratica.lotto == "1"){
              this.fuoriPerimetroBando2_4_4_Lotto1++;
            }else if(pratica.lotto == "5"){
              this.fuoriPerimetroBando2_4_4_Lotto5++;
            }else if(pratica.lotto == "7"){
              this.fuoriPerimetroBando2_4_4_Lotto7++;
            }else if(pratica.lotto == "8"){
              this.fuoriPerimetroBando2_4_4_Lotto8++;
            }
            break;
        }
      }
    }
  }

  loadDatiVincoloTim(pratica: PraticaFlowdy2_Firestore) {
    if (pratica.bando === 'BANDO 1') {
      if((!pratica.statoPF || (pratica.statoPF && (pratica.statoPF == "IN ATTESA" || pratica.statoPF == "KO"))) && pratica.vincoloTipologiaID == 1){
        this.vincoloTimBando1++;
        if(pratica.lotto == "6"){
          this.vincoloTimBando1Lotto6++;
        }else if(pratica.lotto == "7"){
          this.vincoloTimBando1Lotto7++;
        }
        switch(pratica.vincoloCategoriaCodice){
          case '1.3':
            this.vincoloTimBando1_1_3++;
            if(pratica.lotto == "6"){
              this.vincoloTimBando1_1_3_Lotto6++;
            }else if(pratica.lotto == "7"){
              this.vincoloTimBando1_1_3_Lotto7++;
            }
            break;
          case '1.5':
            this.vincoloTimBando1_1_5++;
            if(pratica.lotto == "6"){
              this.vincoloTimBando1_1_5_Lotto6++;
            }else if(pratica.lotto == "7"){
              this.vincoloTimBando1_1_5_Lotto7++;
            }
            break;
          case '1.8':
            this.vincoloTimBando1_1_8++;
            if(pratica.lotto == "6"){
              this.vincoloTimBando1_1_8_Lotto6++;
            }else if(pratica.lotto == "7"){
              this.vincoloTimBando1_1_8_Lotto7++;
            }
            break;
          case '1.9':
            this.vincoloTimBando1_1_9++;
            if(pratica.lotto == "6"){
              this.vincoloTimBando1_1_9_Lotto6++;
            }else if(pratica.lotto == "7"){
              this.vincoloTimBando1_1_9_Lotto7++;
            }
            break;
          case '1.10':
            this.vincoloTimBando1_1_10++;
            if(pratica.lotto == "6"){
              this.vincoloTimBando1_1_10_Lotto6++;
            }else if(pratica.lotto == "7"){
              this.vincoloTimBando1_1_10_Lotto7++;
            }
            break;
          case '1.11':
            this.vincoloTimBando1_1_11++;
            if(pratica.lotto == "6"){
              this.vincoloTimBando1_1_11_Lotto6++;
            }else if(pratica.lotto == "7"){
              this.vincoloTimBando1_1_11_Lotto7++;
            }
            break;
          default:
           // console.log("pratica sgarrata "+ pratica.cui  + " > " + pratica.vincoloCategoriaCodice);    
          }
      }
      
    }else if (pratica.bando === 'BANDO 2') {
      if((!pratica.statoPF || (pratica.statoPF && (pratica.statoPF == "IN ATTESA" || pratica.statoPF == "KO"))) && pratica.vincoloTipologiaID == 1){
        this.vincoloTimBando2++;
        if(pratica.lotto == "1"){
          this.vincoloTimBando2Lotto1++;
        }else if(pratica.lotto == "5"){
          this.vincoloTimBando2Lotto5++;
        }else if(pratica.lotto == "7"){
          this.vincoloTimBando2Lotto7++;
        }else if(pratica.lotto == "8"){
          this.vincoloTimBando2Lotto8++;
        }
        switch(pratica.vincoloCategoriaCodice){
          case '1.3':
            this.vincoloTimBando2_1_3++;
            if(pratica.lotto == "1"){
              this.vincoloTimBando2_1_3_Lotto1++;
            }else if(pratica.lotto == "5"){
                this.vincoloTimBando2_1_3_Lotto5++;
            }else if(pratica.lotto == "7"){
              this.vincoloTimBando2_1_3_Lotto7++;
            }else if(pratica.lotto == "8"){
              this.vincoloTimBando2_1_3_Lotto8++;
            }
            break;
          case '1.5':
            this.vincoloTimBando2_1_5++;
            if(pratica.lotto == "1"){
              this.vincoloTimBando2_1_5_Lotto1++;
            }else if(pratica.lotto == "5"){
              this.vincoloTimBando2_1_5_Lotto5++;
            }else if(pratica.lotto == "7"){
              this.vincoloTimBando2_1_5_Lotto7++;
            }else if(pratica.lotto == "8"){
              this.vincoloTimBando2_1_5_Lotto8++;
            }
            break;
          case '1.8':
            this.vincoloTimBando2_1_8++;
            if(pratica.lotto == "1"){
              this.vincoloTimBando2_1_8_Lotto1++;
            }else if(pratica.lotto == "5"){
              this.vincoloTimBando2_1_8_Lotto5++;
            }else if(pratica.lotto == "7"){
              this.vincoloTimBando2_1_8_Lotto7++;
            }else if(pratica.lotto == "8"){
              this.vincoloTimBando2_1_8_Lotto8++;
            }
            break;
          case '1.9':
            this.vincoloTimBando2_1_9++;
            if(pratica.lotto == "1"){
              this.vincoloTimBando2_1_9_Lotto1++;
            }else if(pratica.lotto == "5"){
              this.vincoloTimBando2_1_9_Lotto5++;
            }else if(pratica.lotto == "7"){
              this.vincoloTimBando2_1_9_Lotto7++;
            }else if(pratica.lotto == "8"){
              this.vincoloTimBando2_1_9_Lotto8++;
            }
            break;
          case '1.10':
            this.vincoloTimBando2_1_10++;
            if(pratica.lotto == "1"){
              this.vincoloTimBando2_1_10_Lotto1++;
            }else if(pratica.lotto == "5"){
              this.vincoloTimBando2_1_10_Lotto5++;
            }else if(pratica.lotto == "7"){
              this.vincoloTimBando2_1_10_Lotto7++;
            }else if(pratica.lotto == "8"){
              this.vincoloTimBando2_1_10_Lotto8++;
            }
            break;
          case '1.11':
            this.vincoloTimBando2_1_11++;
            if(pratica.lotto == "1"){
              this.vincoloTimBando2_1_11_Lotto1++;
            }else if(pratica.lotto == "5"){
              this.vincoloTimBando2_1_11_Lotto5++;
            }else if(pratica.lotto == "7"){
              this.vincoloTimBando2_1_11_Lotto7++;
            }else if(pratica.lotto == "8"){
              this.vincoloTimBando2_1_11_Lotto8++;
            }
            break;
          default:
           // console.log("pratica sgarrata "+ pratica.cui  + " > " + pratica.vincoloCategoriaCodice);
          }
      }
    }
  }

  resetTotaliBando1() {
    // Reset contatori Bando 1
    this.complessivoBando1 = 0;
    this.complessivoBando1Attivate = 0;
    this.complessivoBando1AttivateLotto6 = 0;
    this.complessivoBando1AttivateLotto7 = 0;
    this.complessivoBando1DaAttivare = 0;
    this.complessivoBando1DaAttivareLotto6 = 0;
    this.complessivoBando1DaAttivareLotto7 = 0;
    this.complessivoBando1FuoriPerimetro = 0;
    this.complessivoBando1FuoriPerimetroLotto6 = 0;
    this.complessivoBando1FuoriPerimetroLotto7 = 0;
    this.daAttivareBando1PF = 0;
    this.daAttivareBando1PFLotto6 = 0;
    this.daAttivareBando1PFLotto7 = 0;
    this.daAttivareBando1Lavorabile = 0;
    this.daAttivareBando1LavorabileLotto6 = 0;
    this.daAttivareBando1LavorabileLotto7 = 0;
    this.daAttivareBando1VincoloInfratel = 0;
    this.daAttivareBando1VincoloInfratelLotto6 = 0;
    this.daAttivareBando1VincoloInfratelLotto7 = 0;
    this.daAttivareBando1VincoloOF = 0;
    this.daAttivareBando1VincoloOFLotto6 = 0;
    this.daAttivareBando1VincoloOFLotto7 = 0;
    this.daAttivareBando1VincoloFibercop = 0;
    this.daAttivareBando1VincoloFibercopLotto6 = 0;
    this.daAttivareBando1VincoloFibercopLotto7 = 0;
    this.daAttivareBando1VincoloTim = 0;
    this.daAttivareBando1VincoloTimLotto6 = 0;
    this.daAttivareBando1VincoloTimLotto7 = 0;

    this.lavorabiliBando1 = 0;
    this.lavorabiliBando1Lotto6 = 0;
    this.lavorabiliBando1Lotto7 = 0;

    this.lavorabiliBando1Tim = 0;
    this.lavorabiliBando1TimLotto6 = 0;
    this.lavorabiliBando1TimLotto7 = 0;

    this.lavorabiliBando1Fibercop = 0;
    this.lavorabiliBando1FibercopLotto6 = 0;
    this.lavorabiliBando1FibercopLotto7 = 0;

    this.lavorabiliBando1OF = 0;
    this.lavorabiliBando1OFLotto6 = 0;
    this.lavorabiliBando1OFLotto7 = 0;

    this.lavorabiliBando1Infratel       = 0;
    this.lavorabiliBando1InfratelLotto6 = 0;
    this.lavorabiliBando1InfratelLotto7 = 0;
    
    this.vincoloInfratelBando1_3_1 = 0;
    this.vincoloInfratelBando1Lotto6 = 0;
    this.vincoloInfratelBando1Lotto7 = 0;
    this.vincoloInfratelBando1_3_1 = 0;
    this.vincoloInfratelBando1_3_1_Lotto6 = 0;
    this.vincoloInfratelBando1_3_1_Lotto7 = 0;
    this.vincoloInfratelBando1_3_2 = 0;
    this.vincoloInfratelBando1_3_2_Lotto6 = 0;
    this.vincoloInfratelBando1_3_2_Lotto7 = 0;
    this.vincoloInfratelBando1_3_3 = 0;
    this.vincoloInfratelBando1_3_3_Lotto6 = 0;
    this.vincoloInfratelBando1_3_3_Lotto7 = 0;
    this.vincoloInfratelBando1_3_4 = 0;
    this.vincoloInfratelBando1_3_4_Lotto6 = 0;
    this.vincoloInfratelBando1_3_4_Lotto7 = 0;
    this.vincoloInfratelBando1_3_5 = 0;
    this.vincoloInfratelBando1_3_5_Lotto6 = 0;
    this.vincoloInfratelBando1_3_5_Lotto7 = 0;
    this.vincoloInfratelBando1_3_6 = 0;
    this.vincoloInfratelBando1_3_6_Lotto6 = 0;
    this.vincoloInfratelBando1_3_6_Lotto7 = 0;
    this.vincoloInfratelBando1_3_7 = 0;
    this.vincoloInfratelBando1_3_7_Lotto6 = 0;
    this.vincoloInfratelBando1_3_7_Lotto7 = 0;
    this.vincoloInfratelBando1_3_8 = 0;
    this.vincoloInfratelBando1_3_8_Lotto6 = 0;
    this.vincoloInfratelBando1_3_8_Lotto7 = 0;
    this.vincoloInfratelBando1_3_9 = 0;
    this.vincoloInfratelBando1_3_9_Lotto6 = 0;
    this.vincoloInfratelBando1_3_9_Lotto7 = 0;
    this.vincoloInfratelBando1_3_10 = 0;
    this.vincoloInfratelBando1_3_10_Lotto6 = 0;
    this.vincoloInfratelBando1_3_10_Lotto7 = 0;
    this.vincoloInfratelBando1_3_11 = 0;
    this.vincoloInfratelBando1_3_11_Lotto6 = 0;
    this.vincoloInfratelBando1_3_11_Lotto7 = 0;
    this.vincoloInfratelBando1_3_12 = 0;
    this.vincoloInfratelBando1_3_12_Lotto6 = 0;
    this.vincoloInfratelBando1_3_12_Lotto7 = 0;

    this.vincoloOFBando1_2_1 = 0;
    this.vincoloOFBando1_2_1_Lotto6 = 0;
    this.vincoloOFBando1_2_1_Lotto7 = 0;
    this.vincoloOFBando1_2_2 = 0;
    this.vincoloOFBando1_2_2_Lotto6 = 0;
    this.vincoloOFBando1_2_2_Lotto7 = 0;
    this.vincoloOFBando1_2_3 = 0;
    this.vincoloOFBando1_2_3_Lotto6 = 0;
    this.vincoloOFBando1_2_3_Lotto7 = 0;
    this.vincoloOFBando1_2_4 = 0;
    this.vincoloOFBando1_2_4_Lotto6 = 0;
    this.vincoloOFBando1_2_4_Lotto7 = 0;
    this.vincoloOFBando1_2_5 = 0;
    this.vincoloOFBando1_2_5_Lotto6 = 0;
    this.vincoloOFBando1_2_5_Lotto7 = 0;
    this.vincoloOFBando1_2_6 = 0;
    this.vincoloOFBando1_2_6_Lotto6 = 0;
    this.vincoloOFBando1_2_6_Lotto7 = 0;
    this.vincoloOFBando1_2_7 = 0;
    this.vincoloOFBando1_2_7_Lotto6 = 0;
    this.vincoloOFBando1_2_7_Lotto7 = 0;
    this.vincoloOFBando1_2_8 = 0;
    this.vincoloOFBando1_2_8_Lotto6 = 0;
    this.vincoloOFBando1_2_8_Lotto7 = 0;
    this.vincoloOFBando1_2_9 = 0;
    this.vincoloOFBando1_2_9_Lotto6 = 0;
    this.vincoloOFBando1_2_9_Lotto7 = 0;

    this.vincoloFibercopBando1_1_1 = 0;
    this.vincoloFibercopBando1_1_1_Lotto6 = 0;
    this.vincoloFibercopBando1_1_1_Lotto7 = 0;
    this.vincoloFibercopBando1_1_2 = 0;
    this.vincoloFibercopBando1_1_2_Lotto6 = 0;
    this.vincoloFibercopBando1_1_2_Lotto7 = 0;
    this.vincoloFibercopBando1_1_4 = 0;
    this.vincoloFibercopBando1_1_4_Lotto6 = 0;
    this.vincoloFibercopBando1_1_4_Lotto7 = 0;
    this.vincoloFibercopBando1_1_6 = 0;
    this.vincoloFibercopBando1_1_6_Lotto6 = 0;
    this.vincoloFibercopBando1_1_6_Lotto7 = 0;
    this.vincoloFibercopBando1_1_7 = 0;
    this.vincoloFibercopBando1_1_7_Lotto6 = 0;
    this.vincoloFibercopBando1_1_7_Lotto7 = 0;

    this.vincoloTimBando1 = 0;
    this.vincoloTimBando1_1_3 = 0;
    this.vincoloTimBando1_1_3_Lotto6 = 0;
    this.vincoloTimBando1_1_3_Lotto7 = 0;
    this.vincoloTimBando1_1_5 = 0;
    this.vincoloTimBando1_1_5_Lotto6 = 0;
    this.vincoloTimBando1_1_5_Lotto7 = 0;
    this.vincoloTimBando1_1_8 = 0;
    this.vincoloTimBando1_1_8_Lotto6 = 0;
    this.vincoloTimBando1_1_8_Lotto7 = 0;
    this.vincoloTimBando1_1_9 = 0;
    this.vincoloTimBando1_1_9_Lotto6 = 0;
    this.vincoloTimBando1_1_9_Lotto7 = 0;
    this.vincoloTimBando1_1_10 = 0;
    this.vincoloTimBando1_1_10_Lotto6 = 0;
    this.vincoloTimBando1_1_10_Lotto7 = 0;
    this.vincoloTimBando1_1_11 =  0;
    this.vincoloTimBando1_1_11_Lotto6 = 0;
    this.vincoloTimBando1_1_11_Lotto7 = 0;

    this.fuoriPerimetroBando1 = 0;
    this.fuoriPerimetroBando1Lotto6 = 0;
    this.fuoriPerimetroBando1Lotto7 = 0;

    this.fuoriPerimetroBando1_4_1 = 0;
    this.fuoriPerimetroBando1_4_1_Lotto6 = 0;
    this.fuoriPerimetroBando1_4_1_Lotto7 = 0;

    this.fuoriPerimetroBando1_4_2 = 0;
    this.fuoriPerimetroBando1_4_2_Lotto6 = 0;
    this.fuoriPerimetroBando1_4_2_Lotto7 = 0;

    this.fuoriPerimetroBando1_4_3 = 0;
    this.fuoriPerimetroBando1_4_3_Lotto6 = 0;
    this.fuoriPerimetroBando1_4_3_Lotto7 = 0;

    this.fuoriPerimetroBando1_4_4 = 0;
    this.fuoriPerimetroBando1_4_4_Lotto6 = 0;
    this.fuoriPerimetroBando1_4_4_Lotto7 = 0;
   
   
   

   
  }

  resetTotaliBando2() {
   // Reset contatori Bando 2
   this.complessivoBando2 = 0;
   this.complessivoBando2Attivate = 0;
   this.complessivoBando2AttivateLotto1 = 0;
   this.complessivoBando2AttivateLotto5 = 0;
   this.complessivoBando2AttivateLotto7 = 0;
   this.complessivoBando2AttivateLotto8 = 0;
   this.complessivoBando2DaAttivare = 0;
   this.complessivoBando2DaAttivareLotto1 = 0;
   this.complessivoBando2DaAttivareLotto5 = 0;
   this.complessivoBando2DaAttivareLotto7 = 0;
   this.complessivoBando2DaAttivareLotto8 = 0;
   this.complessivoBando2FuoriPerimetro = 0;
   this.complessivoBando2FuoriPerimetroLotto1 = 0;
   this.complessivoBando2FuoriPerimetroLotto5 = 0;
   this.complessivoBando2FuoriPerimetroLotto7 = 0;
   this.complessivoBando2FuoriPerimetroLotto8 = 0;

   this.daAttivareBando2PF = 0;
   this.daAttivareBando2PFLotto1 = 0;
   this.daAttivareBando2PFLotto5 = 0;
   this.daAttivareBando2PFLotto7 = 0;
   this.daAttivareBando2PFLotto8 = 0;

   this.daAttivareBando2Lavorabile = 0;
   this.daAttivareBando2LavorabileLotto1 = 0;
   this.daAttivareBando2LavorabileLotto5 = 0;
   this.daAttivareBando2LavorabileLotto7 = 0;
   this.daAttivareBando2LavorabileLotto8 = 0;

   this.daAttivareBando2VincoloInfratel = 0;
   this.daAttivareBando2VincoloInfratelLotto1 = 0;
   this.daAttivareBando2VincoloInfratelLotto5 = 0;
   this.daAttivareBando2VincoloInfratelLotto7 = 0;
   this.daAttivareBando2VincoloInfratelLotto8 = 0;

   this.daAttivareBando2VincoloOF = 0;
   this.daAttivareBando2VincoloOFLotto1 = 0;
   this.daAttivareBando2VincoloOFLotto5 = 0;
   this.daAttivareBando2VincoloOFLotto7 = 0;
   this.daAttivareBando2VincoloOFLotto8 = 0;

   this.daAttivareBando2VincoloFibercop = 0;
   this.daAttivareBando2VincoloFibercopLotto1 = 0;
   this.daAttivareBando2VincoloFibercopLotto5 = 0;
   this.daAttivareBando2VincoloFibercopLotto7 = 0;
   this.daAttivareBando2VincoloFibercopLotto8 = 0;

   this.daAttivareBando2VincoloTim = 0;
   this.daAttivareBando2VincoloTimLotto1 = 0;
   this.daAttivareBando2VincoloTimLotto5 = 0;
   this.daAttivareBando2VincoloTimLotto7 = 0;
   this.daAttivareBando2VincoloTimLotto8 = 0;

   this.lavorabiliBando2 = 0;
   this.lavorabiliBando2Lotto1 = 0;
   this.lavorabiliBando2Lotto5 = 0;
   this.lavorabiliBando2Lotto7 = 0;
   this.lavorabiliBando2Lotto8 = 0;

   this.lavorabiliBando2Tim = 0;
   this.lavorabiliBando2TimLotto1 = 0;
   this.lavorabiliBando2TimLotto5 = 0;
   this.lavorabiliBando2TimLotto7 = 0;
   this.lavorabiliBando2TimLotto8 = 0;

   this.lavorabiliBando2Fibercop = 0;
   this.lavorabiliBando2FibercopLotto1 = 0;
   this.lavorabiliBando2FibercopLotto5 = 0;
   this.lavorabiliBando2FibercopLotto7 = 0;
   this.lavorabiliBando2FibercopLotto8 = 0;

   this.lavorabiliBando2OF = 0;
   this.lavorabiliBando2OFLotto1 = 0;
   this.lavorabiliBando2OFLotto5 = 0;
   this.lavorabiliBando2OFLotto7 = 0;
   this.lavorabiliBando2OFLotto8 = 0;
   
   this.lavorabiliBando2Infratel = 0;
   this.lavorabiliBando2InfratelLotto1 = 0;
   this.lavorabiliBando2InfratelLotto5 = 0;
   this.lavorabiliBando2InfratelLotto7 = 0;
   this.lavorabiliBando2InfratelLotto8 = 0;

   this.vincoloInfratelBando2 = 0;
   this.vincoloInfratelBando2Lotto1=0;
   this.vincoloInfratelBando2Lotto5=0;
   this.vincoloInfratelBando2Lotto7=0;
   this.vincoloInfratelBando2Lotto8=0;

   this.vincoloInfratelBando2_3_1 = 0;
   this.vincoloInfratelBando2_3_1_Lotto1 = 0; 
   this.vincoloInfratelBando2_3_1_Lotto5 = 0;
   this.vincoloInfratelBando2_3_1_Lotto7 = 0;
   this.vincoloInfratelBando2_3_1_Lotto8 = 0;

   this.vincoloInfratelBando2_3_2 = 0;
   this.vincoloInfratelBando2_3_2_Lotto1 = 0; 
   this.vincoloInfratelBando2_3_2_Lotto5 = 0;
   this.vincoloInfratelBando2_3_2_Lotto7 = 0;
   this.vincoloInfratelBando2_3_2_Lotto8 = 0;

   this.vincoloInfratelBando2_3_3 = 0;
   this.vincoloInfratelBando2_3_3_Lotto1 = 0; 
   this.vincoloInfratelBando2_3_3_Lotto5 = 0;
   this.vincoloInfratelBando2_3_3_Lotto7 = 0;
   this.vincoloInfratelBando2_3_3_Lotto8 = 0;
  
   this.vincoloInfratelBando2_3_4 = 0;
   this.vincoloInfratelBando2_3_4_Lotto1 = 0; 
   this.vincoloInfratelBando2_3_4_Lotto5 = 0;
   this.vincoloInfratelBando2_3_4_Lotto7 = 0;
   this.vincoloInfratelBando2_3_4_Lotto8 = 0;

   this.vincoloInfratelBando2_3_5 = 0;
   this.vincoloInfratelBando2_3_5_Lotto1 = 0; 
   this.vincoloInfratelBando2_3_5_Lotto5 = 0;
   this.vincoloInfratelBando2_3_5_Lotto7 = 0;
   this.vincoloInfratelBando2_3_5_Lotto8 = 0;

   this.vincoloInfratelBando2_3_6 = 0;
   this.vincoloInfratelBando2_3_6_Lotto1 = 0; 
   this.vincoloInfratelBando2_3_6_Lotto5 = 0;
   this.vincoloInfratelBando2_3_6_Lotto7 = 0;
   this.vincoloInfratelBando2_3_6_Lotto8 = 0;
  
   this.vincoloInfratelBando2_3_7 = 0;
   this.vincoloInfratelBando2_3_7_Lotto1 = 0; 
   this.vincoloInfratelBando2_3_7_Lotto5 = 0;
   this.vincoloInfratelBando2_3_7_Lotto7 = 0;
   this.vincoloInfratelBando2_3_7_Lotto8 = 0;

   this.vincoloInfratelBando2_3_8 = 0;
   this.vincoloInfratelBando2_3_8_Lotto1 = 0; 
   this.vincoloInfratelBando2_3_8_Lotto5 = 0;
   this.vincoloInfratelBando2_3_8_Lotto7 = 0;
   this.vincoloInfratelBando2_3_8_Lotto8 = 0;

   this.vincoloInfratelBando2_3_9 = 0;
   this.vincoloInfratelBando2_3_9_Lotto1 = 0; 
   this.vincoloInfratelBando2_3_9_Lotto5 = 0;
   this.vincoloInfratelBando2_3_9_Lotto7 = 0;
   this.vincoloInfratelBando2_3_9_Lotto8 = 0;

   this.vincoloInfratelBando2_3_10 = 0;
   this.vincoloInfratelBando2_3_10_Lotto1 = 0; 
   this.vincoloInfratelBando2_3_10_Lotto5 = 0;
   this.vincoloInfratelBando2_3_10_Lotto7 = 0;
   this.vincoloInfratelBando2_3_10_Lotto8 = 0;

   this.vincoloInfratelBando2_3_11 = 0;
   this.vincoloInfratelBando2_3_11_Lotto1 = 0; 
   this.vincoloInfratelBando2_3_11_Lotto5 = 0;
   this.vincoloInfratelBando2_3_11_Lotto7 = 0;
   this.vincoloInfratelBando2_3_11_Lotto8 = 0;

   this.vincoloInfratelBando2_3_12 = 0;
   this.vincoloInfratelBando2_3_12_Lotto1 = 0; 
   this.vincoloInfratelBando2_3_12_Lotto5 = 0;
   this.vincoloInfratelBando2_3_12_Lotto7 = 0;
   this.vincoloInfratelBando2_3_12_Lotto8 = 0;

    this.vincoloOFBando2_2_1 = 0;
    this.vincoloOFBando2_2_1_Lotto1 = 0;
    this.vincoloOFBando2_2_1_Lotto5 = 0;
    this.vincoloOFBando2_2_1_Lotto7 = 0;
    this.vincoloOFBando2_2_1_Lotto8 = 0;

    this.vincoloOFBando2_2_2 = 0;
    this.vincoloOFBando2_2_2_Lotto1 = 0;
    this.vincoloOFBando2_2_2_Lotto5 = 0;
    this.vincoloOFBando2_2_2_Lotto7 = 0;
    this.vincoloOFBando2_2_2_Lotto8 = 0;

    this.vincoloOFBando2_2_3 = 0;
    this.vincoloOFBando2_2_3_Lotto1 = 0;
    this.vincoloOFBando2_2_3_Lotto5 = 0;
    this.vincoloOFBando2_2_3_Lotto7 = 0;
    this.vincoloOFBando2_2_3_Lotto8 = 0;

    this.vincoloOFBando2_2_4 = 0;
    this.vincoloOFBando2_2_4_Lotto1 = 0;
    this.vincoloOFBando2_2_4_Lotto5 = 0;
    this.vincoloOFBando2_2_4_Lotto7 = 0;
    this.vincoloOFBando2_2_4_Lotto8 = 0;

    this.vincoloOFBando2_2_5 = 0;
    this.vincoloOFBando2_2_5_Lotto1 = 0;
    this.vincoloOFBando2_2_5_Lotto5 = 0;
    this.vincoloOFBando2_2_5_Lotto7 = 0;
    this.vincoloOFBando2_2_5_Lotto8 = 0;

    this.vincoloOFBando2_2_6 = 0;
    this.vincoloOFBando2_2_6_Lotto1 = 0;
    this.vincoloOFBando2_2_6_Lotto5 = 0;
    this.vincoloOFBando2_2_6_Lotto7 = 0;
    this.vincoloOFBando2_2_6_Lotto8 = 0;

    this.vincoloOFBando2_2_7 = 0;
    this.vincoloOFBando2_2_7_Lotto1 = 0;
    this.vincoloOFBando2_2_7_Lotto5 = 0;
    this.vincoloOFBando2_2_7_Lotto7 = 0;
    this.vincoloOFBando2_2_7_Lotto8 = 0;

    this.vincoloOFBando2_2_8 = 0;
    this.vincoloOFBando2_2_8_Lotto1 = 0;
    this.vincoloOFBando2_2_8_Lotto5 = 0;
    this.vincoloOFBando2_2_8_Lotto7 = 0;
    this.vincoloOFBando2_2_8_Lotto8 = 0;

    this.vincoloOFBando2_2_9 = 0;
    this.vincoloOFBando2_2_9_Lotto1 = 0;
    this.vincoloOFBando2_2_9_Lotto5 = 0;
    this.vincoloOFBando2_2_9_Lotto7 = 0;
    this.vincoloOFBando2_2_9_Lotto8 = 0;
    
    this.vincoloFibercopBando2 = 0;
    this.vincoloFibercopBando2Lotto1 = 0;
    this.vincoloFibercopBando2Lotto5 = 0;
    this.vincoloFibercopBando2Lotto7 = 0;
    this.vincoloFibercopBando2Lotto8 = 0;
    
    this.vincoloFibercopBando2_1_1 = 0;
    this.vincoloFibercopBando2_1_1_Lotto1 = 0;
    this.vincoloFibercopBando2_1_1_Lotto5 = 0;
    this.vincoloFibercopBando2_1_1_Lotto7 = 0;
    this.vincoloFibercopBando2_1_1_Lotto8 = 0;
    
    this.vincoloFibercopBando2_1_2 = 0;
    this.vincoloFibercopBando2_1_2_Lotto1 = 0;
    this.vincoloFibercopBando2_1_2_Lotto5 = 0;
    this.vincoloFibercopBando2_1_2_Lotto7 = 0;
    this.vincoloFibercopBando2_1_2_Lotto8 = 0;

    this.vincoloFibercopBando2_1_4 = 0;
    this.vincoloFibercopBando2_1_4_Lotto1 = 0;
    this.vincoloFibercopBando2_1_4_Lotto5 = 0;
    this.vincoloFibercopBando2_1_4_Lotto7 = 0;
    this.vincoloFibercopBando2_1_4_Lotto8 = 0;

    this.vincoloFibercopBando2_1_6 = 0;
    this.vincoloFibercopBando2_1_6_Lotto1 = 0;
    this.vincoloFibercopBando2_1_6_Lotto5 = 0;
    this.vincoloFibercopBando2_1_6_Lotto7 = 0;
    this.vincoloFibercopBando2_1_6_Lotto8 = 0;

    this.vincoloFibercopBando2_1_7 = 0;
    this.vincoloFibercopBando2_1_7_Lotto1 = 0;
    this.vincoloFibercopBando2_1_7_Lotto5 = 0;
    this.vincoloFibercopBando2_1_7_Lotto7 = 0;
    this.vincoloFibercopBando2_1_7_Lotto8 = 0;

    this.vincoloTimBando2 = 0;
    this.vincoloTimBando2_1_3 = 0;
    this.vincoloTimBando2_1_3_Lotto1 = 0;
    this.vincoloTimBando2_1_3_Lotto5 = 0;
    this.vincoloTimBando2_1_3_Lotto7 = 0;
    this.vincoloTimBando2_1_3_Lotto8 = 0;

    this.vincoloTimBando2_1_5 = 0;
    this.vincoloTimBando2_1_5_Lotto1 = 0;
    this.vincoloTimBando2_1_5_Lotto5 = 0;
    this.vincoloTimBando2_1_5_Lotto7 = 0;
    this.vincoloTimBando2_1_5_Lotto8 = 0;

    this.vincoloTimBando2_1_8 = 0;
    this.vincoloTimBando2_1_8_Lotto1 = 0;
    this.vincoloTimBando2_1_8_Lotto5 = 0;
    this.vincoloTimBando2_1_8_Lotto7 = 0;
    this.vincoloTimBando2_1_8_Lotto8 = 0;

    this.vincoloTimBando2_1_9 = 0;
    this.vincoloTimBando2_1_9_Lotto1 = 0;
    this.vincoloTimBando2_1_9_Lotto5 = 0;
    this.vincoloTimBando2_1_9_Lotto7 = 0;
    this.vincoloTimBando2_1_9_Lotto8 = 0;

    this.vincoloTimBando2_1_10 = 0;
    this.vincoloTimBando2_1_10_Lotto1 = 0;
    this.vincoloTimBando2_1_10_Lotto5 = 0;
    this.vincoloTimBando2_1_10_Lotto7 = 0;
    this.vincoloTimBando2_1_10_Lotto8 = 0;

    this.vincoloTimBando2_1_11 = 0;
    this.vincoloTimBando2_1_11_Lotto1 = 0;
    this.vincoloTimBando2_1_11_Lotto5 = 0;
    this.vincoloTimBando2_1_11_Lotto7 = 0;
    this.vincoloTimBando2_1_11_Lotto8 = 0;
    
    this.fuoriPerimetroBando2 = 0;
    this.fuoriPerimetroBando2Lotto1 = 0;
    this.fuoriPerimetroBando2Lotto5 = 0;
    this.fuoriPerimetroBando2Lotto7 = 0;
    this.fuoriPerimetroBando2Lotto8 = 0;

    this.fuoriPerimetroBando2_4_1 = 0;
    this.fuoriPerimetroBando2_4_1_Lotto1 = 0;
    this.fuoriPerimetroBando2_4_1_Lotto5 = 0;
    this.fuoriPerimetroBando2_4_1_Lotto7 = 0;
    this.fuoriPerimetroBando2_4_1_Lotto8 = 0;
    
    this.fuoriPerimetroBando2_4_2 = 0;
    this.fuoriPerimetroBando2_4_2_Lotto1 = 0;
    this.fuoriPerimetroBando2_4_2_Lotto5 = 0;
    this.fuoriPerimetroBando2_4_2_Lotto7 = 0;
    this.fuoriPerimetroBando2_4_2_Lotto8 = 0;
    
    this.fuoriPerimetroBando2_4_3 = 0;
    this.fuoriPerimetroBando2_4_3_Lotto1 = 0;
    this.fuoriPerimetroBando2_4_3_Lotto5 = 0;
    this.fuoriPerimetroBando2_4_3_Lotto7 = 0;
    this.fuoriPerimetroBando2_4_3_Lotto8 = 0;
    
    this.fuoriPerimetroBando2_4_4 = 0;
    this.fuoriPerimetroBando2_4_4_Lotto1 = 0;
    this.fuoriPerimetroBando2_4_4_Lotto5 = 0;
    this.fuoriPerimetroBando2_4_4_Lotto7 = 0;
    this.fuoriPerimetroBando2_4_4_Lotto8 = 0;
    
        
    
    

  }

  

  filtraPerRegione(selezione: string) {
    if(this.activeTabIndex == 0) {
      this.resetTotaliBando1();
      this.datiRaggruppatiBando1Filtrati = [];
     // this.logger.info("[HOME OVERALL] FILTRA PER REGIONE BANDO 1 "+ selezione);
      if (!selezione) {
        this.filterIsSet = false;
        this.datiRaggruppatiBando1Filtrati = [...this.datiRaggruppatiBando1];
        this.labelRegioni = "TUTTE LE REGIONI";
      } else {
        this.filterIsSet = true;
        this.labelRegioni = "REGIONE " + selezione.toUpperCase();
        this.datiRaggruppatiBando1Filtrati = this.datiRaggruppatiBando1.filter(dato => {
          return dato.regione === selezione;
        });

       // this.resetTotaliBando1();
       // this.logger.info("[HOME OVERALL] FILTRA PER REGIONE BANDO 1 I DATI ORIGINALI ERANO "+  this.datiRaggruppatiBando1.length + " I DATI FILTRATI SONO "+  this.datiRaggruppatiBando1Filtrati.length);

        if(this.datiRaggruppatiBando1Filtrati.length > 0) {
          this.datiRaggruppatiBando1Filtrati.forEach(dato => {
            this.preparaDati(dato);
          });
        }

      }
    } else if(this.activeTabIndex == 1) {
      this.resetTotaliBando2();
      this.datiRaggruppatiBando2Filtrati = [];
      if (!selezione) {
        this.filterIsSet = false;
        this.datiRaggruppatiBando2Filtrati = [...this.datiRaggruppatiBando2];
        this.labelRegioni = "TUTTE LE REGIONI";
      } else {
        this.filterIsSet  = true;
        this.labelRegioni = "REGIONE " + selezione.toUpperCase();
        this.datiRaggruppatiBando2Filtrati = this.datiRaggruppatiBando2.filter(dato => {
          return dato.regione === selezione;
        });
       // this.logger.info("[HOME OVERALL] FILTRA PER REGIONE BANDO 2 I DATI ORIGINALI ERANO "+  this.datiRaggruppatiBando2.length + " I DATI FILTRATI SONO "+  this.datiRaggruppatiBando2Filtrati.length);

        if(this.datiRaggruppatiBando2Filtrati.length > 0) {
          this.datiRaggruppatiBando2Filtrati.forEach(dato => {
            this.preparaDati(dato);
          });
        }
      }
    }
  }

  removeFilter() {
    this.filterIsSet = false;
    this.filtroRegione = [];
    this.labelRegioni = "TUTTE LE REGIONI";
    if(this.activeTabIndex == 0) {
    //  this.datiRaggruppatiBando1Filtrati = [...this.datiRaggruppatiFase1Bando1];
      this.loadDatiBando1();
    } else if(this.activeTabIndex == 1) {
    //  this.datiRaggruppatiBando2Filtrati = [...this.datiRaggruppatiFase1Bando2];
      this.loadDatiBando2();
    }
  }

  caricaTotaliBando1() {
    // Implementazione del caricamento dei totali bando 1
  }

  caricaTotaliBando2() {
    // Implementazione del caricamento dei totali bando 2
  }

  scaricaReport() {
    // Implementazione del download del report
  }
  downloadDaAttivare(){

    this.logger.info("[HOME OVERALL] DOWNLOAD DA ATTIVARE");
    if(this.activeTabIndex== 0){
      const datiBando1 = {
        daAttivareBando1: this.daAttivareBando1,
        daAttivareBando1PF: this.daAttivareBando1PF,
        daAttivareBando1PFLotto6: this.daAttivareBando1PFLotto6,
        daAttivareBando1PFLotto7: this.daAttivareBando1PFLotto7,
        daAttivareBando1Lavorabile: this.daAttivareBando1Lavorabile,
        daAttivareBando1LavorabileLotto6: this.daAttivareBando1LavorabileLotto6,
        daAttivareBando1LavorabileLotto7: this.daAttivareBando1LavorabileLotto7,
        daAttivareBando1VincoloInfratel: this.daAttivareBando1VincoloInfratel,
        daAttivareBando1VincoloInfratelLotto6: this.daAttivareBando1VincoloInfratelLotto6,
        daAttivareBando1VincoloInfratelLotto7: this.daAttivareBando1VincoloInfratelLotto7,
        daAttivareBando1VincoloOF: this.daAttivareBando1VincoloOF,
        daAttivareBando1VincoloOFLotto6: this.daAttivareBando1VincoloOFLotto6,
        daAttivareBando1VincoloOFLotto7: this.daAttivareBando1VincoloOFLotto7,
        daAttivareBando1VincoloFibercop: this.daAttivareBando1VincoloFibercop,
        daAttivareBando1VincoloFibercopLotto6: this.daAttivareBando1VincoloFibercopLotto6,
        daAttivareBando1VincoloFibercopLotto7: this.daAttivareBando1VincoloFibercopLotto7,
        daAttivareBando1VincoloTim: this.daAttivareBando1VincoloTim,
        daAttivareBando1VincoloTimLotto6: this.daAttivareBando1VincoloTimLotto6,
        daAttivareBando1VincoloTimLotto7: this.daAttivareBando1VincoloTimLotto7,
      
      };
      const filename = `OVERALL_DA_ATTIVARE_BANDO1_${this.utilService.formattaDataDaDate(new Date())}.xlsx`;

      this.excelService.exportBando1OverallDaAttivareToExcel(datiBando1,this.datiRaggruppatiBando1Filtrati.length > 0?this.datiRaggruppatiBando1Filtrati:this.datiRaggruppatiBando1 , filename);
  
    }else if(this.activeTabIndex== 1){
      const datiBando2 = {
        daAttivareBando2: this.daAttivareBando2,
        daAttivareBando2PF: this.daAttivareBando2PF,
        daAttivareBando2PFLotto1: this.daAttivareBando2PFLotto1,
        daAttivareBando2PFLotto5: this.daAttivareBando2PFLotto5,
        daAttivareBando2PFLotto7: this.daAttivareBando2PFLotto7,
        daAttivareBando2PFLotto8: this.daAttivareBando2PFLotto8,
        daAttivareBando2Lavorabile: this.daAttivareBando2Lavorabile,
        daAttivareBando2LavorabileLotto1: this.daAttivareBando2LavorabileLotto1,
        daAttivareBando2LavorabileLotto5: this.daAttivareBando2LavorabileLotto5,
        daAttivareBando2LavorabileLotto7: this.daAttivareBando2LavorabileLotto7,
        daAttivareBando2LavorabileLotto8: this.daAttivareBando2LavorabileLotto8,
        daAttivareBando2VincoloInfratel: this.daAttivareBando2VincoloInfratel,
        daAttivareBando2VincoloInfratelLotto1: this.daAttivareBando2VincoloInfratelLotto1,
        daAttivareBando2VincoloInfratelLotto5: this.daAttivareBando2VincoloInfratelLotto5,
        daAttivareBando2VincoloInfratelLotto7: this.daAttivareBando2VincoloInfratelLotto7,
        daAttivareBando2VincoloInfratelLotto8: this.daAttivareBando2VincoloInfratelLotto8,

        daAttivareBando2VincoloOF: this.daAttivareBando2VincoloOF,
        daAttivareBando2VincoloOFLotto1: this.daAttivareBando2VincoloOFLotto1,
        daAttivareBando2VincoloOFLotto5: this.daAttivareBando2VincoloOFLotto5,
        daAttivareBando2VincoloOFLotto7: this.daAttivareBando2VincoloOFLotto7,
        daAttivareBando2VincoloOFLotto8: this.daAttivareBando2VincoloOFLotto8,
        daAttivareBando2VincoloFibercop: this.daAttivareBando2VincoloFibercop,
        daAttivareBando2VincoloFibercopLotto1: this.daAttivareBando2VincoloFibercopLotto1,
        daAttivareBando2VincoloFibercopLotto5: this.daAttivareBando2VincoloFibercopLotto5,
        daAttivareBando2VincoloFibercopLotto7: this.daAttivareBando2VincoloFibercopLotto7,
        daAttivareBando2VincoloFibercopLotto8: this.daAttivareBando2VincoloFibercopLotto8,
        daAttivareBando2VincoloTim: this.daAttivareBando2VincoloTim,
        daAttivareBando2VincoloTimLotto1: this.daAttivareBando2VincoloTimLotto1,
        daAttivareBando2VincoloTimLotto5: this.daAttivareBando2VincoloTimLotto5,
        daAttivareBando2VincoloTimLotto7: this.daAttivareBando2VincoloTimLotto7,
        daAttivareBando2VincoloTimLotto8: this.daAttivareBando2VincoloTimLotto8,
      };
      const filename = `OVERALL_DA_ATTIVARE_BANDO2_${this.utilService.formattaDataDaDate(new Date())}.xlsx`;

      this.excelService.exportBando2OverallDaAttivareToExcel(datiBando2,this.datiRaggruppatiBando2Filtrati.length > 0?this.datiRaggruppatiBando2Filtrati:this.datiRaggruppatiBando2 , filename);
    }
  }
  downloadComplessivo(){
    if(this.activeTabIndex== 0){
      const datiBando1 = {
        complessivoBando1: this.complessivoBando1,
        complessivoBando1Attivate: this.complessivoBando1Attivate,
        complessivoBando1AttivateLotto6: this.complessivoBando1AttivateLotto6,
        complessivoBando1AttivateLotto7: this.complessivoBando1AttivateLotto7,
        complessivoBando1DaAttivare: this.complessivoBando1DaAttivare,
        complessivoBando1DaAttivareLotto6: this.complessivoBando1DaAttivareLotto6,
        complessivoBando1DaAttivareLotto7: this.complessivoBando1DaAttivareLotto7,
        complessivoBando1FuoriPerimetro: this.complessivoBando1FuoriPerimetro,
        complessivoBando1FuoriPerimetroLotto6: this.complessivoBando1FuoriPerimetroLotto6,
        complessivoBando1FuoriPerimetroLotto7: this.complessivoBando1FuoriPerimetroLotto7,
        
      };
      const filename = `OVERALL_COMPLESSIVO_BANDO1_${this.utilService.formattaDataDaDate(new Date())}.xlsx`;

      this.excelService.exportBando1OverallComplessivoToExcel(datiBando1,this.datiRaggruppatiBando1Filtrati.length > 0?this.datiRaggruppatiBando1Filtrati:this.datiRaggruppatiBando1 , filename);
    }else if(this.activeTabIndex== 1){
      const datiBando2 = {
        complessivoBando2: this.complessivoBando2,
        complessivoBando2Attivate: this.complessivoBando2Attivate,
        complessivoBando2AttivateLotto1: this.complessivoBando2AttivateLotto1,
        complessivoBando2AttivateLotto5: this.complessivoBando2AttivateLotto5,
        complessivoBando2AttivateLotto7: this.complessivoBando2AttivateLotto7,
        complessivoBando2AttivateLotto8: this.complessivoBando2AttivateLotto8,
        complessivoBando2DaAttivare: this.complessivoBando2DaAttivare,
        complessivoBando2DaAttivareLotto1: this.complessivoBando2DaAttivareLotto1,
        complessivoBando2DaAttivareLotto5: this.complessivoBando2DaAttivareLotto5,
        complessivoBando2DaAttivareLotto7: this.complessivoBando2DaAttivareLotto7,
        complessivoBando2DaAttivareLotto8: this.complessivoBando2DaAttivareLotto8,
        complessivoBando2FuoriPerimetro: this.complessivoBando2FuoriPerimetro,
        complessivoBando2FuoriPerimetroLotto1: this.complessivoBando2FuoriPerimetroLotto1,
        complessivoBando2FuoriPerimetroLotto5: this.complessivoBando2FuoriPerimetroLotto5,
        complessivoBando2FuoriPerimetroLotto7: this.complessivoBando2FuoriPerimetroLotto7,
        complessivoBando2FuoriPerimetroLotto8: this.complessivoBando2FuoriPerimetroLotto8,
      };
      const filename = `OVERALL_COMPLESSIVO_BANDO2_${this.utilService.formattaDataDaDate(new Date())}.xlsx`;

      this.excelService.exportBando2OverallComplessivoToExcel(datiBando2,this.datiRaggruppatiBando2Filtrati.length > 0?this.datiRaggruppatiBando2Filtrati:this.datiRaggruppatiBando2 , filename);
    }
  }

  downloadReport() {
    try {
      if(this.activeTabIndex== 0){
        const datiBando1 = {
          complessivoBando1: this.complessivoBando1,
          complessivoBando1Attivate: this.complessivoBando1Attivate,
          complessivoBando1AttivateLotto6: this.complessivoBando1AttivateLotto6,
          complessivoBando1AttivateLotto7: this.complessivoBando1AttivateLotto7,
          complessivoBando1DaAttivare: this.complessivoBando1DaAttivare,
          complessivoBando1DaAttivareLotto6: this.complessivoBando1DaAttivareLotto6,
          complessivoBando1DaAttivareLotto7: this.complessivoBando1DaAttivareLotto7,
          complessivoBando1FuoriPerimetro: this.complessivoBando1FuoriPerimetro,
          complessivoBando1FuoriPerimetroLotto6: this.complessivoBando1FuoriPerimetroLotto6,
          complessivoBando1FuoriPerimetroLotto7: this.complessivoBando1FuoriPerimetroLotto7,
          daAttivareBando1: this.daAttivareBando1,
          daAttivareBando1PF: this.daAttivareBando1PF,
          daAttivareBando1PFLotto6: this.daAttivareBando1PFLotto6,
          daAttivareBando1PFLotto7: this.daAttivareBando1PFLotto7,
          daAttivareBando1Lavorabile: this.daAttivareBando1Lavorabile,
          daAttivareBando1LavorabileLotto6: this.daAttivareBando1LavorabileLotto6,
          daAttivareBando1LavorabileLotto7: this.daAttivareBando1LavorabileLotto7,
          daAttivareBando1VincoloInfratel: this.daAttivareBando1VincoloInfratel,
          daAttivareBando1VincoloInfratelLotto6: this.daAttivareBando1VincoloInfratelLotto6,
          daAttivareBando1VincoloInfratelLotto7: this.daAttivareBando1VincoloInfratelLotto7,
          daAttivareBando1VincoloOF: this.daAttivareBando1VincoloOF,
          daAttivareBando1VincoloOFLotto6: this.daAttivareBando1VincoloOFLotto6,
          daAttivareBando1VincoloOFLotto7: this.daAttivareBando1VincoloOFLotto7,
          daAttivareBando1VincoloFibercop: this.daAttivareBando1VincoloFibercop,
          daAttivareBando1VincoloFibercopLotto6: this.daAttivareBando1VincoloFibercopLotto6,
          daAttivareBando1VincoloFibercopLotto7: this.daAttivareBando1VincoloFibercopLotto7,
          daAttivareBando1VincoloTim: this.daAttivareBando1VincoloTim,
          daAttivareBando1VincoloTimLotto6: this.daAttivareBando1VincoloTimLotto6,
          daAttivareBando1VincoloTimLotto7: this.daAttivareBando1VincoloTimLotto7,
          fuoriPerimetroBando1: this.fuoriPerimetroBando1,
          fuoriPerimetroBando1_4_1: this.fuoriPerimetroBando1_4_1,
          fuoriPerimetroBando1_4_1_Lotto6: this.fuoriPerimetroBando1_4_1_Lotto6,
          fuoriPerimetroBando1_4_1_Lotto7: this.fuoriPerimetroBando1_4_1_Lotto7,
          fuoriPerimetroBando1_4_2: this.fuoriPerimetroBando1_4_2,
          fuoriPerimetroBando1_4_2_Lotto6: this.fuoriPerimetroBando1_4_2_Lotto6,
          fuoriPerimetroBando1_4_2_Lotto7: this.fuoriPerimetroBando1_4_2_Lotto7,
          fuoriPerimetroBando1_4_3: this.fuoriPerimetroBando1_4_3,
          fuoriPerimetroBando1_4_3_Lotto6: this.fuoriPerimetroBando1_4_3_Lotto6,
          fuoriPerimetroBando1_4_3_Lotto7: this.fuoriPerimetroBando1_4_3_Lotto7,
          fuoriPerimetroBando1_4_4: this.fuoriPerimetroBando1_4_4,
          fuoriPerimetroBando1_4_4_Lotto6: this.fuoriPerimetroBando1_4_4_Lotto6,
          fuoriPerimetroBando1_4_4_Lotto7: this.fuoriPerimetroBando1_4_4_Lotto7,
          lavorabiliBando1: this.lavorabiliBando1,
          lavorabiliBando1Lotto6: this.lavorabiliBando1Lotto6,
          lavorabiliBando1Lotto7: this.lavorabiliBando1Lotto7,
          lavorabiliBando1Tim: this.lavorabiliBando1Tim,
          lavorabiliBando1TimLotto6: this.lavorabiliBando1TimLotto6,
          lavorabiliBando1TimLotto7: this.lavorabiliBando1TimLotto7,
          lavorabiliBando1Fibercop: this.lavorabiliBando1Fibercop,
          lavorabiliBando1FibercopLotto6: this.lavorabiliBando1FibercopLotto6,
          lavorabiliBando1FibercopLotto7: this.lavorabiliBando1FibercopLotto7,
          lavorabiliBando1OF: this.lavorabiliBando1OF,
          lavorabiliBando1OFLotto6: this.lavorabiliBando1OFLotto6,
          lavorabiliBando1OFLotto7: this.lavorabiliBando1OFLotto7,
          lavorabiliBando1Infratel: this.lavorabiliBando1Infratel,
          lavorabiliBando1InfratelLotto6: this.lavorabiliBando1InfratelLotto6,
          lavorabiliBando1InfratelLotto7: this.lavorabiliBando1InfratelLotto7,
          vincoloInfratelBando1: this.vincoloInfratelBando1,
          vincoloInfratelBando1Lotto6: this.vincoloInfratelBando1Lotto6,
          vincoloInfratelBando1Lotto7: this.vincoloInfratelBando1Lotto7,
          vincoloInfratelBando1_3_1: this.vincoloInfratelBando1_3_1,
          vincoloInfratelBando1_3_1_Lotto6: this.vincoloInfratelBando1_3_1_Lotto6,
          vincoloInfratelBando1_3_1_Lotto7: this.vincoloInfratelBando1_3_1_Lotto7,
          vincoloInfratelBando1_3_2: this.vincoloInfratelBando1_3_2,
          vincoloInfratelBando1_3_2_Lotto6: this.vincoloInfratelBando1_3_2_Lotto6,
          vincoloInfratelBando1_3_2_Lotto7: this.vincoloInfratelBando1_3_2_Lotto7,
          vincoloInfratelBando1_3_3: this.vincoloInfratelBando1_3_3,
          vincoloInfratelBando1_3_3_Lotto6: this.vincoloInfratelBando1_3_3_Lotto6,
          vincoloInfratelBando1_3_3_Lotto7: this.vincoloInfratelBando1_3_3_Lotto7,
          vincoloInfratelBando1_3_4: this.vincoloInfratelBando1_3_4,
          vincoloInfratelBando1_3_4_Lotto6: this.vincoloInfratelBando1_3_4_Lotto6,
          vincoloInfratelBando1_3_4_Lotto7: this.vincoloInfratelBando1_3_4_Lotto7,
          vincoloInfratelBando1_3_5: this.vincoloInfratelBando1_3_5,
          vincoloInfratelBando1_3_5_Lotto6: this.vincoloInfratelBando1_3_5_Lotto6,
          vincoloInfratelBando1_3_5_Lotto7: this.vincoloInfratelBando1_3_5_Lotto7,
          vincoloInfratelBando1_3_6: this.vincoloInfratelBando1_3_6,
          vincoloInfratelBando1_3_6_Lotto6: this.vincoloInfratelBando1_3_6_Lotto6,
          vincoloInfratelBando1_3_6_Lotto7: this.vincoloInfratelBando1_3_6_Lotto7,
          vincoloInfratelBando1_3_7: this.vincoloInfratelBando1_3_7,
          vincoloInfratelBando1_3_7_Lotto6: this.vincoloInfratelBando1_3_7_Lotto6,
          vincoloInfratelBando1_3_7_Lotto7: this.vincoloInfratelBando1_3_7_Lotto7,
          vincoloInfratelBando1_3_8: this.vincoloInfratelBando1_3_8,
          vincoloInfratelBando1_3_8_Lotto6: this.vincoloInfratelBando1_3_8_Lotto6,
          vincoloInfratelBando1_3_8_Lotto7: this.vincoloInfratelBando1_3_8_Lotto7,
          vincoloInfratelBando1_3_9: this.vincoloInfratelBando1_3_9,
          vincoloInfratelBando1_3_9_Lotto6: this.vincoloInfratelBando1_3_9_Lotto6,
          vincoloInfratelBando1_3_9_Lotto7: this.vincoloInfratelBando1_3_9_Lotto7,
          vincoloInfratelBando1_3_10: this.vincoloInfratelBando1_3_10,
          vincoloInfratelBando1_3_10_Lotto6: this.vincoloInfratelBando1_3_10_Lotto6,
          vincoloInfratelBando1_3_10_Lotto7: this.vincoloInfratelBando1_3_10_Lotto7,
          vincoloInfratelBando1_3_11: this.vincoloInfratelBando1_3_11,
          vincoloInfratelBando1_3_11_Lotto6: this.vincoloInfratelBando1_3_11_Lotto6,
          vincoloInfratelBando1_3_11_Lotto7: this.vincoloInfratelBando1_3_11_Lotto7,
          vincoloInfratelBando1_3_12: this.vincoloInfratelBando1_3_12,
          vincoloInfratelBando1_3_12_Lotto6: this.vincoloInfratelBando1_3_12_Lotto6,
          vincoloInfratelBando1_3_12_Lotto7: this.vincoloInfratelBando1_3_12_Lotto7,
          
          vincoloOFBando1: this.vincoloOFBando1,
          vincoloOFBando1Lotto6: this.vincoloOFBando1Lotto6,
          vincoloOFBando1Lotto7: this.vincoloOFBando1Lotto7,
          vincoloOFBando1_2_1: this.vincoloOFBando1_2_1,
          vincoloOFBando1_2_1_Lotto6: this.vincoloOFBando1_2_1_Lotto6,
          vincoloOFBando1_2_1_Lotto7: this.vincoloOFBando1_2_1_Lotto7,
          vincoloOFBando1_2_2: this.vincoloOFBando1_2_2,
          vincoloOFBando1_2_2_Lotto6: this.vincoloOFBando1_2_2_Lotto6,
          vincoloOFBando1_2_2_Lotto7: this.vincoloOFBando1_2_2_Lotto7,
          vincoloOFBando1_2_3: this.vincoloOFBando1_2_3,
          vincoloOFBando1_2_3_Lotto6: this.vincoloOFBando1_2_3_Lotto6,
          vincoloOFBando1_2_3_Lotto7: this.vincoloOFBando1_2_3_Lotto7,
          vincoloOFBando1_2_4: this.vincoloOFBando1_2_4,
          vincoloOFBando1_2_4_Lotto6: this.vincoloOFBando1_2_4_Lotto6,
          vincoloOFBando1_2_4_Lotto7: this.vincoloOFBando1_2_4_Lotto7,
          vincoloOFBando1_2_5: this.vincoloOFBando1_2_5,
          vincoloOFBando1_2_5_Lotto6: this.vincoloOFBando1_2_5_Lotto6,
          vincoloOFBando1_2_5_Lotto7: this.vincoloOFBando1_2_5_Lotto7,
          vincoloOFBando1_2_6: this.vincoloOFBando1_2_6,
          vincoloOFBando1_2_6_Lotto6: this.vincoloOFBando1_2_6_Lotto6,
          vincoloOFBando1_2_6_Lotto7: this.vincoloOFBando1_2_6_Lotto7,
          vincoloOFBando1_2_7: this.vincoloOFBando1_2_7,
          vincoloOFBando1_2_7_Lotto6: this.vincoloOFBando1_2_7_Lotto6,
          vincoloOFBando1_2_7_Lotto7: this.vincoloOFBando1_2_7_Lotto7,
          vincoloOFBando1_2_8: this.vincoloOFBando1_2_8,
          vincoloOFBando1_2_8_Lotto6: this.vincoloOFBando1_2_8_Lotto6,
          vincoloOFBando1_2_8_Lotto7: this.vincoloOFBando1_2_8_Lotto7,
          vincoloOFBando1_2_9: this.vincoloOFBando1_2_9,
          vincoloOFBando1_2_9_Lotto6: this.vincoloOFBando1_2_9_Lotto6,
          vincoloOFBando1_2_9_Lotto7: this.vincoloOFBando1_2_9_Lotto7,
         
          vincoloFibercopBando1: this.vincoloFibercopBando1,
          vincoloFibercopBando1Lotto6: this.vincoloFibercopBando1Lotto6,
          vincoloFibercopBando1Lotto7: this.vincoloFibercopBando1Lotto7,
          vincoloFibercopBando1_1_1: this.vincoloFibercopBando1_1_1,
          vincoloFibercopBando1_1_1_Lotto6: this.vincoloFibercopBando1_1_1_Lotto6,
          vincoloFibercopBando1_1_1_Lotto7: this.vincoloFibercopBando1_1_1_Lotto7,
          vincoloFibercopBando1_1_2: this.vincoloFibercopBando1_1_2,
          vincoloFibercopBando1_1_2_Lotto6: this.vincoloFibercopBando1_1_2_Lotto6,
          vincoloFibercopBando1_1_2_Lotto7: this.vincoloFibercopBando1_1_2_Lotto7,
          vincoloFibercopBando1_1_4: this.vincoloFibercopBando1_1_4,
          vincoloFibercopBando1_1_4_Lotto6: this.vincoloFibercopBando1_1_4_Lotto6,
          vincoloFibercopBando1_1_4_Lotto7: this.vincoloFibercopBando1_1_4_Lotto7,
          vincoloFibercopBando1_1_6: this.vincoloFibercopBando1_1_6,
          vincoloFibercopBando1_1_6_Lotto6: this.vincoloFibercopBando1_1_6_Lotto6,
          vincoloFibercopBando1_1_6_Lotto7: this.vincoloFibercopBando1_1_6_Lotto7,
          vincoloFibercopBando1_1_7: this.vincoloFibercopBando1_1_7,
          vincoloFibercopBando1_1_7_Lotto6: this.vincoloFibercopBando1_1_7_Lotto6,
          vincoloFibercopBando1_1_7_Lotto7: this.vincoloFibercopBando1_1_7_Lotto7,

          vincoloTimBando1: this.vincoloTimBando1,
          vincoloTimBando1Lotto6: this.vincoloTimBando1Lotto6,
          vincoloTimBando1Lotto7: this.vincoloTimBando1Lotto7,
          vincoloTimBando1_1_3: this.vincoloTimBando1_1_3,
          vincoloTimBando1_1_3_Lotto6: this.vincoloTimBando1_1_3_Lotto6,
          vincoloTimBando1_1_3_Lotto7: this.vincoloTimBando1_1_3_Lotto7,
          vincoloTimBando1_1_5: this.vincoloTimBando1_1_5,
          vincoloTimBando1_1_5_Lotto6: this.vincoloTimBando1_1_5_Lotto6,
          vincoloTimBando1_1_5_Lotto7: this.vincoloTimBando1_1_5_Lotto7,
          vincoloTimBando1_1_8: this.vincoloTimBando1_1_8,
          vincoloTimBando1_1_8_Lotto6: this.vincoloTimBando1_1_8_Lotto6,
          vincoloTimBando1_1_8_Lotto7: this.vincoloTimBando1_1_8_Lotto7,
          vincoloTimBando1_1_9: this.vincoloTimBando1_1_9,
          vincoloTimBando1_1_9_Lotto6: this.vincoloTimBando1_1_9_Lotto6,
          vincoloTimBando1_1_9_Lotto7: this.vincoloTimBando1_1_9_Lotto7,
          vincoloTimBando1_1_10: this.vincoloTimBando1_1_10,
          vincoloTimBando1_1_10_Lotto6: this.vincoloTimBando1_1_10_Lotto6,
          vincoloTimBando1_1_10_Lotto7: this.vincoloTimBando1_1_10_Lotto7, 
          vincoloTimBando1_1_11: this.vincoloTimBando1_1_11,
          vincoloTimBando1_1_11_Lotto6: this.vincoloTimBando1_1_11_Lotto6,
          vincoloTimBando1_1_11_Lotto7: this.vincoloTimBando1_1_11_Lotto7,


        };
        const filename = `OVERALL_BANDO1_${this.utilService.formattaDataDaDate(new Date())}.xlsx`;
  
        this.excelService.exportBando1OverallToExcel(datiBando1, filename);
      }else{
        this.logger.info(this.daAttivareBando2VincoloOF + " "+ this.daAttivareBando2VincoloOFLotto1 + " "+ this.daAttivareBando2VincoloOFLotto5 + " "
           + this.daAttivareBando2VincoloOFLotto7 + " "
           + this.daAttivareBando2VincoloOFLotto8
        )
        const datiBando2 = {
          complessivoBando2: this.complessivoBando2,
          complessivoBando2Attivate: this.complessivoBando2Attivate,
          complessivoBando2AttivateLotto1: this.complessivoBando2AttivateLotto1,
          complessivoBando2AttivateLotto5: this.complessivoBando2AttivateLotto5,
          complessivoBando2AttivateLotto7: this.complessivoBando2AttivateLotto7,
          complessivoBando2AttivateLotto8: this.complessivoBando2AttivateLotto8,
          complessivoBando2DaAttivare: this.complessivoBando2DaAttivare,
          complessivoBando2DaAttivareLotto1: this.complessivoBando2DaAttivareLotto1,
          complessivoBando2DaAttivareLotto5: this.complessivoBando2DaAttivareLotto5,
          complessivoBando2DaAttivareLotto7: this.complessivoBando2DaAttivareLotto7,
          complessivoBando2DaAttivareLotto8: this.complessivoBando2DaAttivareLotto8,
          complessivoBando2FuoriPerimetro: this.complessivoBando2FuoriPerimetro,
          complessivoBando2FuoriPerimetroLotto1: this.complessivoBando2FuoriPerimetroLotto1,
          complessivoBando2FuoriPerimetroLotto5: this.complessivoBando2FuoriPerimetroLotto5,
          complessivoBando2FuoriPerimetroLotto7: this.complessivoBando2FuoriPerimetroLotto7,
          complessivoBando2FuoriPerimetroLotto8: this.complessivoBando2FuoriPerimetroLotto8,

          daAttivareBando2: this.daAttivareBando2,
          daAttivareBando2PF: this.daAttivareBando2PF,
          daAttivareBando2PFLotto1: this.daAttivareBando2PFLotto1,
          daAttivareBando2PFLotto5: this.daAttivareBando2PFLotto5,
          daAttivareBando2PFLotto7: this.daAttivareBando2PFLotto7,
          daAttivareBando2PFLotto8: this.daAttivareBando2PFLotto8,
          daAttivareBando2Lavorabile: this.daAttivareBando2Lavorabile,
          daAttivareBando2LavorabileLotto1: this.daAttivareBando2LavorabileLotto1,
          daAttivareBando2LavorabileLotto5: this.daAttivareBando2LavorabileLotto5,
          daAttivareBando2LavorabileLotto7: this.daAttivareBando2LavorabileLotto7,
          daAttivareBando2LavorabileLotto8: this.daAttivareBando2LavorabileLotto8,
          daAttivareBando2VincoloInfratel: this.daAttivareBando2VincoloInfratel,
          daAttivareBando2VincoloInfratelLotto1: this.daAttivareBando2VincoloInfratelLotto1,
          daAttivareBando2VincoloInfratelLotto5: this.daAttivareBando2VincoloInfratelLotto5,
          daAttivareBando2VincoloInfratelLotto7: this.daAttivareBando2VincoloInfratelLotto7,
          daAttivareBando2VincoloInfratelLotto8: this.daAttivareBando2VincoloInfratelLotto8,

          daAttivareBando2VincoloOF: this.daAttivareBando2VincoloOF,
          daAttivareBando2VincoloOFLotto1: this.daAttivareBando2VincoloOFLotto1,
          daAttivareBando2VincoloOFLotto5: this.daAttivareBando2VincoloOFLotto5,
          daAttivareBando2VincoloOFLotto7: this.daAttivareBando2VincoloOFLotto7,
          daAttivareBando2VincoloOFLotto8: this.daAttivareBando2VincoloOFLotto8,
          daAttivareBando2VincoloFibercop: this.daAttivareBando2VincoloFibercop,
          daAttivareBando2VincoloFibercopLotto1: this.daAttivareBando2VincoloFibercopLotto1,
          daAttivareBando2VincoloFibercopLotto5: this.daAttivareBando2VincoloFibercopLotto5,
          daAttivareBando2VincoloFibercopLotto7: this.daAttivareBando2VincoloFibercopLotto7,
          daAttivareBando2VincoloFibercopLotto8: this.daAttivareBando2VincoloFibercopLotto8,
          daAttivareBando2VincoloTim: this.daAttivareBando2VincoloTim,
          daAttivareBando2VincoloTimLotto1: this.daAttivareBando2VincoloTimLotto1,
          daAttivareBando2VincoloTimLotto5: this.daAttivareBando2VincoloTimLotto5,
          daAttivareBando2VincoloTimLotto7: this.daAttivareBando2VincoloTimLotto7,
          daAttivareBando2VincoloTimLotto8: this.daAttivareBando2VincoloTimLotto8,

          fuoriPerimetroBando2: this.fuoriPerimetroBando2,
          fuoriPerimetroBando2_4_1: this.fuoriPerimetroBando2_4_1,
          fuoriPerimetroBando2_4_1_Lotto1: this.fuoriPerimetroBando2_4_1_Lotto1,
          fuoriPerimetroBando2_4_1_Lotto5: this.fuoriPerimetroBando2_4_1_Lotto5,
          fuoriPerimetroBando2_4_1_Lotto7: this.fuoriPerimetroBando2_4_1_Lotto7,
          fuoriPerimetroBando2_4_1_Lotto8: this.fuoriPerimetroBando2_4_1_Lotto8,
          fuoriPerimetroBando2_4_2: this.fuoriPerimetroBando2_4_2,
          fuoriPerimetroBando2_4_2_Lotto1: this.fuoriPerimetroBando2_4_2_Lotto1,
          fuoriPerimetroBando2_4_2_Lotto5: this.fuoriPerimetroBando2_4_2_Lotto5,
          fuoriPerimetroBando2_4_2_Lotto7: this.fuoriPerimetroBando2_4_2_Lotto7,
          fuoriPerimetroBando2_4_2_Lotto8: this.fuoriPerimetroBando2_4_2_Lotto8,
          fuoriPerimetroBando2_4_3: this.fuoriPerimetroBando2_4_3,
          fuoriPerimetroBando2_4_3_Lotto1: this.fuoriPerimetroBando2_4_3_Lotto1,
          fuoriPerimetroBando2_4_3_Lotto5: this.fuoriPerimetroBando2_4_3_Lotto5,
          fuoriPerimetroBando2_4_3_Lotto7: this.fuoriPerimetroBando2_4_3_Lotto7,
          fuoriPerimetroBando2_4_3_Lotto8: this.fuoriPerimetroBando2_4_3_Lotto8,
          fuoriPerimetroBando2_4_4: this.fuoriPerimetroBando2_4_4,
          fuoriPerimetroBando2_4_4_Lotto1: this.fuoriPerimetroBando2_4_4_Lotto1,
          fuoriPerimetroBando2_4_4_Lotto5: this.fuoriPerimetroBando2_4_4_Lotto5,
          fuoriPerimetroBando2_4_4_Lotto7: this.fuoriPerimetroBando2_4_4_Lotto7,
          fuoriPerimetroBando2_4_4_Lotto8: this.fuoriPerimetroBando2_4_4_Lotto8,
          fuoriPerimetroBando1_4_4_Lotto7: this.fuoriPerimetroBando1_4_4_Lotto7,

          lavorabiliBando2: this.lavorabiliBando2,
          lavorabiliBando2Lotto1: this.lavorabiliBando2Lotto1,
          lavorabiliBando2Lotto5: this.lavorabiliBando2Lotto5,
          lavorabiliBando2Lotto7: this.lavorabiliBando2Lotto7,
          lavorabiliBando2Lotto8: this.lavorabiliBando2Lotto8,
          
          lavorabiliBando2Tim: this.lavorabiliBando2Tim,
          lavorabiliBando2TimLotto1: this.lavorabiliBando2TimLotto1,
          lavorabiliBando2TimLotto5: this.lavorabiliBando2TimLotto5,
          lavorabiliBando2TimLotto7: this.lavorabiliBando2TimLotto7,
          lavorabiliBando2TimLotto8: this.lavorabiliBando2TimLotto8,
          lavorabiliBando2Fibercop: this.lavorabiliBando2Fibercop,
          lavorabiliBando2FibercopLotto1: this.lavorabiliBando2FibercopLotto1,
          lavorabiliBando2FibercopLotto5: this.lavorabiliBando2FibercopLotto5,
          lavorabiliBando2FibercopLotto7: this.lavorabiliBando2FibercopLotto7,
          lavorabiliBando2FibercopLotto8: this.lavorabiliBando2FibercopLotto8,
          lavorabiliBando2OF: this.lavorabiliBando2OF,
          lavorabiliBando2OFLotto1: this.lavorabiliBando2OFLotto1,
          lavorabiliBando2OFLotto5: this.lavorabiliBando2OFLotto5,
          lavorabiliBando2OFLotto7: this.lavorabiliBando2OFLotto7,
          lavorabiliBando2OFLotto8: this.lavorabiliBando2OFLotto8,
          lavorabiliBando2Infratel: this.lavorabiliBando2Infratel,
          lavorabiliBando2InfratelLotto1: this.lavorabiliBando2InfratelLotto1,
          lavorabiliBando2InfratelLotto5: this.lavorabiliBando2InfratelLotto5,
          lavorabiliBando2InfratelLotto7: this.lavorabiliBando2InfratelLotto7,
          lavorabiliBando2InfratelLotto8: this.lavorabiliBando2InfratelLotto8,

          vincoloInfratelBando2: this.vincoloInfratelBando2,
          vincoloInfratelBando2Lotto1: this.vincoloInfratelBando2Lotto1,
          vincoloInfratelBando2Lotto5: this.vincoloInfratelBando2Lotto5,
          vincoloInfratelBando2Lotto7: this.vincoloInfratelBando2Lotto7,
          vincoloInfratelBando2Lotto8: this.vincoloInfratelBando2Lotto8,
          vincoloInfratelBando2_3_1: this.vincoloInfratelBando2_3_1,
          vincoloInfratelBando2_3_1_Lotto1: this.vincoloInfratelBando2_3_1_Lotto1,
          vincoloInfratelBando2_3_1_Lotto5: this.vincoloInfratelBando2_3_1_Lotto5,
          vincoloInfratelBando2_3_1_Lotto7: this.vincoloInfratelBando2_3_1_Lotto7,
          vincoloInfratelBando2_3_1_Lotto8: this.vincoloInfratelBando2_3_1_Lotto8,
          vincoloInfratelBando2_3_2: this.vincoloInfratelBando2_3_2,
          vincoloInfratelBando2_3_2_Lotto1: this.vincoloInfratelBando2_3_2_Lotto1,
          vincoloInfratelBando2_3_2_Lotto5: this.vincoloInfratelBando2_3_2_Lotto5,
          vincoloInfratelBando2_3_2_Lotto7: this.vincoloInfratelBando2_3_2_Lotto7,
          vincoloInfratelBando2_3_2_Lotto8: this.vincoloInfratelBando2_3_2_Lotto8,
          vincoloInfratelBando2_3_3: this.vincoloInfratelBando2_3_3,
          vincoloInfratelBando2_3_3_Lotto1: this.vincoloInfratelBando2_3_3_Lotto1,
          vincoloInfratelBando2_3_3_Lotto5: this.vincoloInfratelBando2_3_3_Lotto5,
          vincoloInfratelBando2_3_3_Lotto7: this.vincoloInfratelBando2_3_3_Lotto7,
          vincoloInfratelBando2_3_3_Lotto8: this.vincoloInfratelBando2_3_3_Lotto8,
          vincoloInfratelBando2_3_4: this.vincoloInfratelBando2_3_4,
          vincoloInfratelBando2_3_4_Lotto1: this.vincoloInfratelBando2_3_4_Lotto1,
          vincoloInfratelBando2_3_4_Lotto5: this.vincoloInfratelBando2_3_4_Lotto5,
          vincoloInfratelBando2_3_4_Lotto7: this.vincoloInfratelBando2_3_4_Lotto7,
          vincoloInfratelBando2_3_4_Lotto8: this.vincoloInfratelBando2_3_4_Lotto8,
          vincoloInfratelBando2_3_5: this.vincoloInfratelBando2_3_5,
          vincoloInfratelBando2_3_5_Lotto1: this.vincoloInfratelBando2_3_5_Lotto1,
          vincoloInfratelBando2_3_5_Lotto5: this.vincoloInfratelBando2_3_5_Lotto5,
          vincoloInfratelBando2_3_5_Lotto7: this.vincoloInfratelBando2_3_5_Lotto7,
          vincoloInfratelBando2_3_5_Lotto8: this.vincoloInfratelBando2_3_5_Lotto8,
          vincoloInfratelBando2_3_6: this.vincoloInfratelBando2_3_6,
          vincoloInfratelBando2_3_6_Lotto1: this.vincoloInfratelBando2_3_6_Lotto1,
          vincoloInfratelBando2_3_6_Lotto5: this.vincoloInfratelBando2_3_6_Lotto5,
          vincoloInfratelBando2_3_6_Lotto7: this.vincoloInfratelBando2_3_6_Lotto7,
          vincoloInfratelBando2_3_6_Lotto8: this.vincoloInfratelBando2_3_6_Lotto8,
          vincoloInfratelBando2_3_7: this.vincoloInfratelBando2_3_7,
          vincoloInfratelBando2_3_7_Lotto1: this.vincoloInfratelBando2_3_7_Lotto1,
          vincoloInfratelBando2_3_7_Lotto5: this.vincoloInfratelBando2_3_7_Lotto5,
          vincoloInfratelBando2_3_7_Lotto7: this.vincoloInfratelBando2_3_7_Lotto7,
          vincoloInfratelBando2_3_7_Lotto8: this.vincoloInfratelBando2_3_7_Lotto8,
          vincoloInfratelBando2_3_8: this.vincoloInfratelBando2_3_8,
          vincoloInfratelBando2_3_8_Lotto1: this.vincoloInfratelBando2_3_8_Lotto1,
          vincoloInfratelBando2_3_8_Lotto5: this.vincoloInfratelBando2_3_8_Lotto5,
          vincoloInfratelBando2_3_8_Lotto7: this.vincoloInfratelBando2_3_8_Lotto7,
          vincoloInfratelBando2_3_8_Lotto8: this.vincoloInfratelBando2_3_8_Lotto8,
          vincoloInfratelBando2_3_9: this.vincoloInfratelBando2_3_9,
          vincoloInfratelBando2_3_9_Lotto1: this.vincoloInfratelBando2_3_9_Lotto1,
          vincoloInfratelBando2_3_9_Lotto5: this.vincoloInfratelBando2_3_9_Lotto5,
          vincoloInfratelBando2_3_9_Lotto7: this.vincoloInfratelBando2_3_9_Lotto7,
          vincoloInfratelBando2_3_9_Lotto8: this.vincoloInfratelBando2_3_9_Lotto8,
          vincoloInfratelBando2_3_10: this.vincoloInfratelBando2_3_10,
          vincoloInfratelBando2_3_10_Lotto1: this.vincoloInfratelBando2_3_10_Lotto1,
          vincoloInfratelBando2_3_10_Lotto5: this.vincoloInfratelBando2_3_10_Lotto5,
          vincoloInfratelBando2_3_10_Lotto7: this.vincoloInfratelBando2_3_10_Lotto7,
          vincoloInfratelBando2_3_10_Lotto8: this.vincoloInfratelBando2_3_10_Lotto8,
          vincoloInfratelBando2_3_11: this.vincoloInfratelBando2_3_11,
          vincoloInfratelBando2_3_11_Lotto1: this.vincoloInfratelBando2_3_11_Lotto1,
          vincoloInfratelBando2_3_11_Lotto5: this.vincoloInfratelBando2_3_11_Lotto5,
          vincoloInfratelBando2_3_11_Lotto7: this.vincoloInfratelBando2_3_11_Lotto7,
          vincoloInfratelBando2_3_11_Lotto8: this.vincoloInfratelBando2_3_11_Lotto8,
          vincoloInfratelBando2_3_12: this.vincoloInfratelBando2_3_12,
          vincoloInfratelBando2_3_12_Lotto1: this.vincoloInfratelBando2_3_12_Lotto1,
          vincoloInfratelBando2_3_12_Lotto5: this.vincoloInfratelBando2_3_12_Lotto5,
          vincoloInfratelBando2_3_12_Lotto7: this.vincoloInfratelBando2_3_12_Lotto7,
          vincoloInfratelBando2_3_12_Lotto8: this.vincoloInfratelBando2_3_12_Lotto8,
          
          vincoloOFBando2: this.vincoloOFBando2,
          vincoloOFBando2Lotto1: this.vincoloOFBando2Lotto1,  
          vincoloOFBando2Lotto5: this.vincoloOFBando2Lotto5,
          vincoloOFBando2Lotto7: this.vincoloOFBando2Lotto7,
          vincoloOFBando2Lotto8: this.vincoloOFBando2Lotto8,
          vincoloOFBando2_2_1: this.vincoloOFBando2_2_1,
          vincoloOFBando2_2_1_Lotto1: this.vincoloOFBando2_2_1_Lotto1,
          vincoloOFBando2_2_1_Lotto5: this.vincoloOFBando2_2_1_Lotto5,
          vincoloOFBando2_2_1_Lotto7: this.vincoloOFBando2_2_1_Lotto7,
          vincoloOFBando2_2_1_Lotto8: this.vincoloOFBando2_2_1_Lotto8,
          vincoloOFBando2_2_2: this.vincoloOFBando2_2_2,
          vincoloOFBando2_2_2_Lotto1: this.vincoloOFBando2_2_2_Lotto1,
          vincoloOFBando2_2_2_Lotto5: this.vincoloOFBando2_2_2_Lotto5,
          vincoloOFBando2_2_2_Lotto7: this.vincoloOFBando2_2_2_Lotto7,
          vincoloOFBando2_2_2_Lotto8: this.vincoloOFBando2_2_2_Lotto8,
          vincoloOFBando2_2_3: this.vincoloOFBando2_2_3,
          vincoloOFBando2_2_3_Lotto1: this.vincoloOFBando2_2_3_Lotto1,    
          vincoloOFBando2_2_3_Lotto5: this.vincoloOFBando2_2_3_Lotto5,
          vincoloOFBando2_2_3_Lotto7: this.vincoloOFBando2_2_3_Lotto7,
          vincoloOFBando2_2_3_Lotto8: this.vincoloOFBando2_2_3_Lotto8,
          vincoloOFBando2_2_4: this.vincoloOFBando2_2_4,
          vincoloOFBando2_2_4_Lotto1: this.vincoloOFBando2_2_4_Lotto1,
          vincoloOFBando2_2_4_Lotto5: this.vincoloOFBando2_2_4_Lotto5,
          vincoloOFBando2_2_4_Lotto7: this.vincoloOFBando2_2_4_Lotto7,
          vincoloOFBando2_2_4_Lotto8: this.vincoloOFBando2_2_4_Lotto8,
          vincoloOFBando2_2_5: this.vincoloOFBando2_2_5,
          vincoloOFBando2_2_5_Lotto1: this.vincoloOFBando2_2_5_Lotto1,
          vincoloOFBando2_2_5_Lotto5: this.vincoloOFBando2_2_5_Lotto5,
          vincoloOFBando2_2_5_Lotto7: this.vincoloOFBando2_2_5_Lotto7,
          vincoloOFBando2_2_5_Lotto8: this.vincoloOFBando2_2_5_Lotto8,
          vincoloOFBando2_2_6: this.vincoloOFBando2_2_6,
          vincoloOFBando2_2_6_Lotto1: this.vincoloOFBando2_2_6_Lotto1,
          vincoloOFBando2_2_6_Lotto5: this.vincoloOFBando2_2_6_Lotto5,
          vincoloOFBando2_2_6_Lotto7: this.vincoloOFBando2_2_6_Lotto7,
          vincoloOFBando2_2_6_Lotto8: this.vincoloOFBando2_2_6_Lotto8,
          vincoloOFBando2_2_7: this.vincoloOFBando2_2_7,
          vincoloOFBando2_2_7_Lotto1: this.vincoloOFBando2_2_7_Lotto1,
          vincoloOFBando2_2_7_Lotto5: this.vincoloOFBando2_2_7_Lotto5,
          vincoloOFBando2_2_7_Lotto7: this.vincoloOFBando2_2_7_Lotto7,
          vincoloOFBando2_2_7_Lotto8: this.vincoloOFBando2_2_7_Lotto8,
          vincoloOFBando2_2_8: this.vincoloOFBando2_2_8,
          vincoloOFBando2_2_8_Lotto1: this.vincoloOFBando2_2_8_Lotto1,
          vincoloOFBando2_2_8_Lotto5: this.vincoloOFBando2_2_8_Lotto5,
          vincoloOFBando2_2_8_Lotto7: this.vincoloOFBando2_2_8_Lotto7,
          vincoloOFBando2_2_8_Lotto8: this.vincoloOFBando2_2_8_Lotto8,
          vincoloOFBando2_2_9: this.vincoloOFBando2_2_9,
          vincoloOFBando2_2_9_Lotto1: this.vincoloOFBando2_2_9_Lotto1,
          vincoloOFBando2_2_9_Lotto5: this.vincoloOFBando2_2_9_Lotto5,
          vincoloOFBando2_2_9_Lotto7: this.vincoloOFBando2_2_9_Lotto7,
          vincoloOFBando2_2_9_Lotto8: this.vincoloOFBando2_2_9_Lotto8,
        
          vincoloFibercopBando2: this.vincoloFibercopBando2,
          vincoloFibercopBando2Lotto1: this.vincoloFibercopBando2Lotto1,
          vincoloFibercopBando2Lotto5: this.vincoloFibercopBando2Lotto5,
          vincoloFibercopBando2Lotto7: this.vincoloFibercopBando2Lotto7,
          vincoloFibercopBando2Lotto8: this.vincoloFibercopBando2Lotto8,
          vincoloFibercopBando2_1_1: this.vincoloFibercopBando2_1_1,
          vincoloFibercopBando2_1_1_Lotto1: this.vincoloFibercopBando2_1_1_Lotto1,
          vincoloFibercopBando2_1_1_Lotto5: this.vincoloFibercopBando2_1_1_Lotto5,
          vincoloFibercopBando2_1_1_Lotto7: this.vincoloFibercopBando2_1_1_Lotto7,
          vincoloFibercopBando2_1_1_Lotto8: this.vincoloFibercopBando2_1_1_Lotto8,
          vincoloFibercopBando2_1_2: this.vincoloFibercopBando2_1_2,
          vincoloFibercopBando2_1_2_Lotto1: this.vincoloFibercopBando2_1_2_Lotto1,
          vincoloFibercopBando2_1_2_Lotto5: this.vincoloFibercopBando2_1_2_Lotto5,
          vincoloFibercopBando2_1_2_Lotto7: this.vincoloFibercopBando2_1_2_Lotto7,
          vincoloFibercopBando2_1_2_Lotto8: this.vincoloFibercopBando2_1_2_Lotto8,
          vincoloFibercopBando2_1_4: this.vincoloFibercopBando2_1_4,
          vincoloFibercopBando2_1_4_Lotto1: this.vincoloFibercopBando2_1_4_Lotto1,
          vincoloFibercopBando2_1_4_Lotto5: this.vincoloFibercopBando2_1_4_Lotto5,
          vincoloFibercopBando2_1_4_Lotto7: this.vincoloFibercopBando2_1_4_Lotto7,
          vincoloFibercopBando2_1_4_Lotto8: this.vincoloFibercopBando2_1_4_Lotto8,
          vincoloFibercopBando2_1_6: this.vincoloFibercopBando2_1_6,
          vincoloFibercopBando2_1_6_Lotto1: this.vincoloFibercopBando2_1_6_Lotto1,
          vincoloFibercopBando2_1_6_Lotto5: this.vincoloFibercopBando2_1_6_Lotto5,
          vincoloFibercopBando2_1_6_Lotto7: this.vincoloFibercopBando2_1_6_Lotto7,
          vincoloFibercopBando2_1_6_Lotto8: this.vincoloFibercopBando2_1_6_Lotto8,
          vincoloFibercopBando2_1_7: this.vincoloFibercopBando2_1_7,
          vincoloFibercopBando2_1_7_Lotto1: this.vincoloFibercopBando2_1_7_Lotto1,
          vincoloFibercopBando2_1_7_Lotto5: this.vincoloFibercopBando2_1_7_Lotto5,
          vincoloFibercopBando2_1_7_Lotto7: this.vincoloFibercopBando2_1_7_Lotto7,
          vincoloFibercopBando2_1_7_Lotto8: this.vincoloFibercopBando2_1_7_Lotto8,
        
          vincoloTimBando2: this.vincoloTimBando2,
          vincoloTimBando2Lotto1: this.vincoloTimBando2Lotto1,
          vincoloTimBando2Lotto5: this.vincoloTimBando2Lotto5,
          vincoloTimBando2Lotto7: this.vincoloTimBando2Lotto7,
          vincoloTimBando2Lotto8: this.vincoloTimBando2Lotto8,
          vincoloTimBando2_1_3: this.vincoloTimBando2_1_3,
          vincoloTimBando2_1_3_Lotto1: this.vincoloTimBando2_1_3_Lotto1,
          vincoloTimBando2_1_3_Lotto5: this.vincoloTimBando2_1_3_Lotto5,
          vincoloTimBando2_1_3_Lotto7: this.vincoloTimBando2_1_3_Lotto7,
          vincoloTimBando2_1_3_Lotto8: this.vincoloTimBando2_1_3_Lotto8,
          vincoloTimBando2_1_5: this.vincoloTimBando2_1_5,
          vincoloTimBando2_1_5_Lotto1: this.vincoloTimBando2_1_5_Lotto1,  
          vincoloTimBando2_1_5_Lotto5: this.vincoloTimBando2_1_5_Lotto5,
          vincoloTimBando2_1_5_Lotto7: this.vincoloTimBando2_1_5_Lotto7,
          vincoloTimBando2_1_5_Lotto8: this.vincoloTimBando2_1_5_Lotto8,
          vincoloTimBando2_1_8: this.vincoloTimBando2_1_8,
          vincoloTimBando2_1_8_Lotto1: this.vincoloTimBando2_1_8_Lotto1,
          vincoloTimBando2_1_8_Lotto5: this.vincoloTimBando2_1_8_Lotto5,
          vincoloTimBando2_1_8_Lotto7: this.vincoloTimBando2_1_8_Lotto7,
          vincoloTimBando2_1_8_Lotto8: this.vincoloTimBando2_1_8_Lotto8,
          vincoloTimBando2_1_9: this.vincoloTimBando2_1_9,
          vincoloTimBando2_1_9_Lotto1: this.vincoloTimBando2_1_9_Lotto1,
          vincoloTimBando2_1_9_Lotto5: this.vincoloTimBando2_1_9_Lotto5,
          vincoloTimBando2_1_9_Lotto7: this.vincoloTimBando2_1_9_Lotto7,
          vincoloTimBando2_1_9_Lotto8: this.vincoloTimBando2_1_9_Lotto8,
          vincoloTimBando2_1_10: this.vincoloTimBando2_1_10,
          vincoloTimBando2_1_10_Lotto1: this.vincoloTimBando2_1_10_Lotto1,
          vincoloTimBando2_1_10_Lotto5: this.vincoloTimBando2_1_10_Lotto5,
          vincoloTimBando2_1_10_Lotto7: this.vincoloTimBando2_1_10_Lotto7,
          vincoloTimBando2_1_10_Lotto8: this.vincoloTimBando2_1_10_Lotto8,
          vincoloTimBando2_1_11: this.vincoloTimBando2_1_11,
          vincoloTimBando2_1_11_Lotto1: this.vincoloTimBando2_1_11_Lotto1,
          vincoloTimBando2_1_11_Lotto5: this.vincoloTimBando2_1_11_Lotto5,
          vincoloTimBando2_1_11_Lotto7: this.vincoloTimBando2_1_11_Lotto7,
          vincoloTimBando2_1_11_Lotto8: this.vincoloTimBando2_1_11_Lotto8



        };

        const filename = `OVERALL_BANDO2_${this.utilService.formattaDataDaDate(new Date())}.xlsx`;
  
        this.excelService.exportBando2OverallToExcel(datiBando2, filename);
      }
      

     
 
    

      this.messageService.add({
        severity: 'success',
        summary: 'Report Generato',
        detail: 'Il report è stato generato con successo'
      });
    } catch (error) {
      this.logger.error('Errore durante la generazione del report:', error);
      this.messageService.add({
        severity: 'error',
        summary: 'Errore',
        detail: 'Si è verificato un errore durante la generazione del report'
      });
    }
  }

  showDettaglioDaAttivare() {
    this.showDaAttivareTable = !this.showDaAttivareTable;
    if (this.showDaAttivareTable) {
      this.showLavorabileTable = false;
      this.isDettaglioVincoloInfratelVisible = false;
      this.isDettaglioVincoloOFVisible = false;
      this.isDettaglioVincoloFibercopVisible = false;
      this.isDettaglioVincoloTimVisible = false;
    }
  }

  showDettaglioFuoriPerimetro() {
    this.isDettaglioFuoriPerimetroVisible = !this.isDettaglioFuoriPerimetroVisible;
    if (this.isDettaglioFuoriPerimetroVisible) {
      this.showDaAttivareTable = false;
      this.showLavorabileTable = false;
      this.isDettaglioVincoloInfratelVisible = false;
      this.isDettaglioVincoloOFVisible = false;
      this.isDettaglioVincoloFibercopVisible = false;
      this.isDettaglioVincoloTimVisible = false;
    }
  }

  showDettaglioVincoloInfratel(event: Event) {
    event.stopPropagation();
    this.isDettaglioVincoloInfratelVisible = !this.isDettaglioVincoloInfratelVisible;
    this.showLavorabileTable = false;
    setTimeout(() => {

      const table = this.activeTabIndex === 0 ? document.getElementById('dettaglio-vincolo-infratel-bando1') : document.getElementById('dettaglio-vincolo-infratel-bando2');
      if (table) {
        table.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }, 100);
    if (this.isDettaglioVincoloInfratelVisible) {
      this.isDettaglioVincoloOFVisible = false;
      this.isDettaglioVincoloFibercopVisible = false;
      this.isDettaglioVincoloTimVisible = false;
    }
  }

  showDettaglioVincoloOF(event: Event) {
    event.stopPropagation();
    this.isDettaglioVincoloOFVisible = !this.isDettaglioVincoloOFVisible;
    this.showLavorabileTable = false;
    setTimeout(() => {

      const table = this.activeTabIndex === 0 ? document.getElementById('dettaglio-vincolo-of-bando1') : document.getElementById('dettaglio-vincolo-of-bando2');
      if (table) {
        table.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }, 100);
    if (this.isDettaglioVincoloOFVisible) {
      this.isDettaglioVincoloInfratelVisible = false;
      this.isDettaglioVincoloFibercopVisible = false;
      this.isDettaglioVincoloTimVisible = false;
    }
  }

  showDettaglioVincoloFibercop(event: Event) {
    event.stopPropagation();
    this.isDettaglioVincoloFibercopVisible = !this.isDettaglioVincoloFibercopVisible;
    this.showLavorabileTable = false;
    setTimeout(() => {

      const table = this.activeTabIndex === 0 ? document.getElementById('dettaglio-vincolo-fibercop-bando1') : document.getElementById('dettaglio-vincolo-fibercop-bando2');
      if (table) {
        table.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }, 100);
    if (this.isDettaglioVincoloFibercopVisible) {
      this.isDettaglioVincoloInfratelVisible = false;
      this.isDettaglioVincoloOFVisible = false;
      this.isDettaglioVincoloTimVisible = false;
    }
  }

  showDettaglioVincoloTim(event: Event) {
    event.stopPropagation();
    this.isDettaglioVincoloTimVisible = !this.isDettaglioVincoloTimVisible;
    this.showLavorabileTable = false;
    if (this.showDaAttivareTable) {
      setTimeout(() => {

        const table = this.activeTabIndex === 0 ? document.getElementById('dettaglio-vincolo-tim-bando1') : document.getElementById('dettaglio-vincolo-tim-bando2');
        if (table) {
          table.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }, 100);
    }
    if (this.isDettaglioVincoloTimVisible) {
      this.isDettaglioVincoloInfratelVisible = false;
      this.isDettaglioVincoloOFVisible = false;
      this.isDettaglioVincoloFibercopVisible = false;
    }
  }

  showDaAttivare() {
    this.showDaAttivareTable = true;
    this.showLavorabileTable = false;
    this.isDettaglioFuoriPerimetroVisible = false;
    if (this.showDaAttivareTable) {
      setTimeout(() => {

        const table = this.activeTabIndex === 0 ? document.getElementById('dettaglio-da-attivare-bando1') : document.getElementById('dettaglio-da-attivare-bando2');
        if (table) {
          table.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }, 100);
    }
  }

  showLavorabile() {
    this.showLavorabileTable = true;
    this.isDettaglioFuoriPerimetroVisible = false;
    this.isDettaglioVincoloInfratelVisible = false;
    this.isDettaglioVincoloOFVisible = false;
    this.isDettaglioVincoloFibercopVisible = false;
    this.isDettaglioVincoloTimVisible = false;
    if (this.showLavorabileTable) {
      setTimeout(() => {
        const table = this.activeTabIndex === 0 ? document.getElementById('dettaglio-lavorabile-bando1') : document.getElementById('dettaglio-lavorabile-bando2');
        if (table) {
          table.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }, 100);
    }
  }

  

  
} 
